import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  deleteDesignation,
  getAdditionDiductionType,
  getCategorys,
  getDepartments,
  getDesignation,
  GetDynamicOptions,
  getEmployee,
  getGroup,
  GetLateDeduction,
  getPayrollDetails,
  getProfitCenter,
  InsertDuty,
  insertEmpPayrollData,
  InsertUnAutherisePayrollUserDetails,
  UnAuthorizePayroll,
} from "../../services/dataService";
import Breadcrumb from "../../components/common/Breadcrumb";
import { event } from "jquery";
import toast from "react-hot-toast";
import {
  IconDeselect,
  IconEdit,
  IconEye,
  IconPlus,
  IconTrash,
} from "@tabler/icons-react";
import { Await, useLocation } from "react-router-dom";
import Loading from "../../components/common/Loading";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";

function Payrole() {
  const UID = getSecureItem("userId");

  const [salaryOptions, setSalaryOptions] = useState([]);
  const [Remark, setRemark] = useState("");
  // const [selectedOption, setSelectedOption] = useState("Daily");
  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");
  const [apprveall, setApproveall] = useState(false);
  const [DeductionData, setDeductionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [PayrollData, setPayrollData] = useState([]);
  const [additionsDeductions, setAdditionsDeductions] = useState([]);
  const [isAdditionsModalOpen, setAdditionsModalOpen] = useState(false);
  const [isDeductionsModalOpen, setDeductionsModalOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterPages, setFilterPages] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  const [payrollApprovedFilter, setPayrollApproveFilter] = useState("all"); // New state for PayScaleId filter
  const [unauthorizeAllChecked, setUnauthorizeAllChecked] = useState(false);
  const [loading, setloading] = useState(false);
  const location = useLocation(); // Access the location object
  const { uncheckedPayrollData } = location.state || {}; // Safely destructure state
  const [unApproveModal, setUnApproveModal] = useState(false);
  const [unApproveUser, setUnApproveUser] = useState([
    {
      Reason: "",
      UserId: "",
    },
  ]);

  const [selectedEmployeesForUnauthorize, setSelectedEmployeesForUnauthorize] =
    useState({}); // Object for unauthorize
  const [datafilter, setDataFilter] = useState([]);
  const [category, setCategory] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [lastDataLength, setLastDataLength] = useState(0); // Track previous data length
  const [editId, setEditId] = useState(null); // Track which row is being edited
  const [editAmount, setEditAmount] = useState(""); // Store the new amount
  const [editdeductionAmount, seteditdeductionAmount] = useState("");
  const [editdeductionId, setEditdeductionId] = useState(null);
  const [additionDidductionType, setAdditionDidductionType] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Daily");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [deductions, setDeductions] = useState([
    { amount: "", description: "" },
  ]);
  const [addition, setAddition] = useState([
    { additionAmount: "", additionDescription: "" },
  ]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [editableWorkingDays, setEditableWorkingDays] = useState({});
  const [editableWorkingHours, setEditableWorkingHours] = useState({});
  const [editingEmployees, setEditingEmployees] = useState({});
  const [breakdownModalOpen, setBreakdownModalOpen] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [editAdditionIndex, setEditAdditionIndex] = useState(null); // Track which addition is being edited
  const [editAdditionAmount, setEditAdditionAmount] = useState(""); // Store the new addition amount
  const [editDeductionIndex, setEditDeductionIndex] = useState(null); // Track which deduction is being edited
  const [editDeductionAmount, setEditDeductionAmount] = useState(""); // Store the new deduction amount
  const [temp, setTemp] = useState([]); // Store the new deduction amount

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filteredPayrollData = datafilter?.filter((employee) => {
    // Search term filter
    const term = searchTerm.toLowerCase();
    const matchesSearch =
      !searchTerm ||
      employee?.Name.toLowerCase().includes(term) ||
      (employee?.Code && employee?.Code.toLowerCase().includes(term));
    // Payroll approval filter
    let matchesApproval = true;
    if (payrollApprovedFilter === "not-null") {
      matchesApproval = employee?.IsChecked === 1;
    } else if (payrollApprovedFilter === "null") {
      matchesApproval = employee?.IsChecked == null || !employee?.IsChecked;
    } else {
      matchesApproval = true; // 'all' case, include all records
    }

    return matchesSearch && matchesApproval;
  });

  const handlepayrollApprovedFilterChange = (e) => {
    const value = e.target.value;
    setPayrollApproveFilter(value);
    setTemp({ ...temp, payrollApprovedFilter: value }); // Persist in tempState
    setSecureItem("payrollApprovedFilter", value); // Persist in localStorage
  };
  // Load persisted filter on component mount
  const currentItems =
    filteredPayrollData?.slice(indexOfFirstItem, indexOfLastItem) || [];

  const totalPages = Math.ceil(filteredPayrollData?.length / itemsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchdedution = async () => {
    const data = {
      FromDate: fromDate || new Date().toISOString().split("T")[0],
      ToDate: toDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setloading(true); // Use consistent naming (setloading instead of setLoading)
      const response = await GetLateDeduction(data);
      setDeductionData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching deduction data", error);
      toast.error("Failed to fetch deduction data");
    } finally {
      //setloading(false);
    }
  };

  
  const processAllEmployees = () => {
    let updatedAdditionsDeductions = [...additionsDeductions];

    // STEP 1: COMBINE DUPLICATES (unchanged)
    const combinedComponents = {};
    updatedAdditionsDeductions.forEach((item) => {
      const key = `${item.EmpId}_${item.ComponentName}_${item.ComponentType}`;
      if (!combinedComponents[key]) {
        combinedComponents[key] = {
          ...item,
          BaseAmount: item.BaseAmount || 0,
          CalculatedAmount: item.CalculatedAmount || 0,
          WageTypeIds: item.WageTypeId ? [item.WageTypeId] : [],
          WageTypeNames: item.WageTypeName ? [item.WageTypeName] : [],
          WageComponentIds: item.WageComponentId ? [item.WageComponentId] : [],
          WageComponentNames: item.WageComponentName
            ? [item.WageComponentName]
            : [],
        };
      } else {
        if (combinedComponents[key].ValueType?.includes("Percentage")) {
          combinedComponents[key].BaseAmount = Math.max(
            combinedComponents[key].BaseAmount,
            item.BaseAmount || 0,
          );
        } else {
          combinedComponents[key].BaseAmount += item.BaseAmount || 0;
        }
        combinedComponents[key].CalculatedAmount += item.CalculatedAmount || 0;

        if (
          item.WageTypeId &&
          !combinedComponents[key].WageTypeIds.includes(item.WageTypeId)
        ) {
          combinedComponents[key].WageTypeIds.push(item.WageTypeId);
        }
        if (
          item.WageTypeName &&
          !combinedComponents[key].WageTypeNames.includes(item.WageTypeName)
        ) {
          combinedComponents[key].WageTypeNames.push(item.WageTypeName);
        }
        if (
          item.WageComponentId &&
          !combinedComponents[key].WageComponentIds.includes(
            item.WageComponentId,
          )
        ) {
          combinedComponents[key].WageComponentIds.push(item.WageComponentId);
        }
        if (
          item.WageComponentName &&
          !combinedComponents[key].WageComponentNames.includes(
            item.WageComponentName,
          )
        ) {
          combinedComponents[key].WageComponentNames.push(
            item.WageComponentName,
          );
        }
      }
    });

    updatedAdditionsDeductions = Object.values(combinedComponents).map(
      (item) => ({
        ...item,
        WageTypeId: item.WageTypeIds.filter(Boolean).join(",") || null,
        WageTypeName: item.WageTypeNames.filter(Boolean).join("+") || null,
        WageComponentId:
          item.WageComponentIds.filter(Boolean).join(",") || null,
        WageComponentName:
          item.WageComponentNames.filter(Boolean).join("+") || null,
        BaseAmount: Math.round(item.BaseAmount),
        CalculatedAmount: Math.round(item.CalculatedAmount),
      }),
    );

    updatedAdditionsDeductions = updatedAdditionsDeductions.map(
      ({
        WageTypeIds,
        WageTypeNames,
        WageComponentIds,
        WageComponentNames,
        ...rest
      }) => rest,
    );

    // STEP 2: BASIC PRO-RATING (unchanged)
    PayrollData.forEach((employee) => {
      const empId = employee?.EmpId;
      const totalWorkingDays = employee?.TotalWorkingDays;
      const totalempday =
        editableWorkingDays[empId] != null
          ? Number(editableWorkingDays[empId] ?? 0) +
            Number(employee?.TotalLeaveDays ?? 0) +
            Number(employee?.TotalHalfDay ?? 0)
          : Number(employee?.EmployeeTotalWorkingDays ?? 0) +
            Number(employee?.TotalLeaveDays ?? 0) +
            Number(employee?.TotalHalfDay ?? 0);

      const basicComponentIndex = updatedAdditionsDeductions.findIndex(
        (el) =>
          el.EmpId == empId &&
          el.ComponentName?.toLowerCase() === "basic" &&
          el.ComponentType?.toLowerCase() === "addition type",
      );

      if (basicComponentIndex !== -1) {
        const basicComponent = updatedAdditionsDeductions[basicComponentIndex];
        let basic = basicComponent.BaseAmount || 0;
        const updatedBasic =
          selectedOption === "Monthly" ? basic / totalWorkingDays : basic || 0;
        let totalBasicForMonth =
          selectedOption === "Monthly"
            ? employee?.Id
              ? Math.round(basic)
              : Math.round(updatedBasic * totalempday)
            : Math.round(updatedBasic * totalempday);

        updatedAdditionsDeductions[basicComponentIndex] = {
          ...basicComponent,
          CalculatedAmount: totalBasicForMonth,
        };

        updatedAdditionsDeductions = updatedAdditionsDeductions.map((el) => {
          if (
            el?.EmpId === empId &&
            el?.WageTypeName?.toLowerCase()?.includes("basic") &&
            el?.PercentageValue &&
            el?.ComponentName?.toLowerCase() !== "basic"
          ) {
            return {
              ...el,
              CalculatedAmount: Math.round(
                (totalBasicForMonth * el.PercentageValue) / 100,
              ),
            };
          }
          return el;
        });

        updatedAdditionsDeductions = updatedAdditionsDeductions.map((el) => {
          if (el?.EmpId === empId && el?.ComponentName === "ExcessDeduction") {
            const absentDays = el.BaseAmount || 0;
            const dailyBasicSalary = basic / totalWorkingDays;
            return {
              ...el,
              BaseAmount: Math.round(dailyBasicSalary * absentDays),
              CalculatedAmount: Math.round(dailyBasicSalary * absentDays),
            };
          }
          return el;
        });
      }
    });

    // =========================================================================
    // STEP 2.5: PERCENTAGE COMPONENTS - FIXED WITH PF 15,000 CAP + OVERTIME
    // =========================================================================
    PayrollData.forEach((employee) => {
      const empId = employee?.EmpId;
      const employeeComponents = updatedAdditionsDeductions.filter(
        (item) => item.EmpId === empId,
      );

      employeeComponents.forEach((component) => {
        if (
          component.PercentageValue &&
          component.ValueType?.includes("Percentage") &&
          (component.WageTypeName || component.WageComponentName)
        ) {
          const baseNamesString =
            component.WageTypeName || component.WageComponentName;
          const baseNames = baseNamesString.split("+");

          let totalBaseCalculated = 0;
          baseNames.forEach((baseName) => {
            const baseComponent = employeeComponents.find(
              (item) =>
                item.ComponentName?.toLowerCase() ===
                baseName.trim().toLowerCase(),
            );
            if (baseComponent) {
              totalBaseCalculated += baseComponent.CalculatedAmount || 0;
            }
          });

          let newBaseAmount = Math.round(totalBaseCalculated);

          // PF Cap: If component is PF, cap BaseAmount at 15,000
          if (component.ComponentName?.toLowerCase() === "pf") {
            newBaseAmount = totalBaseCalculated > 15000 ? 15000 : newBaseAmount;
          }

          let newCalculatedAmount = Math.round(
            (newBaseAmount * component.PercentageValue) / 100,
          );

          // ✅ OVERTIME SPECIAL LOGIC
          if (component.ComponentName?.toLowerCase() === "overtime") {
            const totalWorkingDays = employee?.TotalWorkingDays || 1;
            const totalOverTimeMinutes = employee?.TotalOverTimeMinuts || 0;

            // Step 1: PerDay = CalculatedAmount / TotalWorkingDays
            const perDayOverTime = newCalculatedAmount / totalWorkingDays;

            // Step 2: PerHour = PerDay / 8
            const perHourOverTime = perDayOverTime / 8;

            // Step 3: Final = PerHour * TotalOverTimeMinutes / 60
            newCalculatedAmount = Math.round(
              (perHourOverTime * totalOverTimeMinutes) / 60,
            );
          }

          updatedAdditionsDeductions = updatedAdditionsDeductions.map((el) => {
            if (
              el.EmpId === empId &&
              el.ComponentId === component.ComponentId
            ) {
              return {
                ...el,
                BaseAmount: newBaseAmount,
                CalculatedAmount: newCalculatedAmount,
              };
            }
            return el;
          });
        }
      });
    });

    // STEP 3: NESTED PERCENTAGE (unchanged)
    PayrollData.forEach((employee) => {
      const empId = employee?.EmpId;
      const employeeComponents = updatedAdditionsDeductions.filter(
        (item) => item.EmpId === empId,
      );

      const deductionsByComponentId = {};
      employeeComponents.forEach((deduction) => {
        if (!deductionsByComponentId[deduction.ComponentId]) {
          deductionsByComponentId[deduction.ComponentId] = [];
        }
        deductionsByComponentId[deduction.ComponentId].push(deduction);
      });

      Object.keys(deductionsByComponentId).forEach((componentId) => {
        const componentDeductions = deductionsByComponentId[componentId];
        const nestedPercentageItem = componentDeductions.find(
          (item) => item.ValueType === "Nested Percentage",
        );
        if (nestedPercentageItem) {
          const percentageItem = componentDeductions.find(
            (item) => item.ValueType === "Percentage",
          );
          if (percentageItem) {
            const firstLevelPercentage =
              (nestedPercentageItem.BaseAmount *
                nestedPercentageItem.PercentageValue) /
              100;
            const nestedCalculatedAmount =
              (firstLevelPercentage * percentageItem.PercentageValue) / 100;

            updatedAdditionsDeductions = updatedAdditionsDeductions.map(
              (item) => {
                if (item.ComponentId === nestedPercentageItem.ComponentId) {
                  return {
                    ...item,
                    CalculatedAmount: Math.round(nestedCalculatedAmount),
                  };
                }
                return item;
              },
            );
          }
        }
      });
    });

    setAdditionsDeductions(updatedAdditionsDeductions);
  };

  useEffect(() => {
    processAllEmployees();
  }, [editableWorkingDays]);

  // Function to calculate remaining days in current month
  const getRemainingDaysInMonth = (endDate) => {
    const today = new Date();
    const monthEndDate = new Date(endDate);

    // Calculate the difference in time
    const timeDifference = monthEndDate.getTime() - today.getTime();

    // Convert time difference to days (including today)
    const remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24)) + 1;

    return remainingDays > 0 ? remainingDays : 0;
  };

  const fetchData = async () => {
    setloading(true);

    if (fromDate && toDate) {
      try {
        const payload = {
          option: selectedOption,
          fromDate,
          toDate,
          UserId: UID,
        };

        const response = await getPayrollDetails(payload);
        console.log("Payroll Data:", response);

        const approvedItems = response.data.data[0].filter(
          (el) => el.IsChecked == 1,
        );
        setSelectedEmployeesForUnauthorize(approvedItems);
        setPayrollData(response.data.data[0]);
        setAdditionsDeductions(response.data.data[1] || []); // Guard [1]

        // Initialize selected employees
        const initialSelected = {};
        response.data.data[0].forEach((emp) => {
          initialSelected[emp.EmpId] = emp?.IsChecked === 2;
        });
        setSelectedEmployees(initialSelected);

        setDataFilter(response.data.data[0]);

        // Initialize working days/hours
        const initialWorkingDays = {};
        const initialWorkingHours = {};
        response.data.data[0].forEach((emp) => {
          let workingDays = emp.EmployeeTotalWorkingDays;

          if (selectedOption.toLowerCase() === "monthly" && !emp?.Id) {
            const remainingDays = getRemainingDaysInMonth(toDate);
            workingDays += remainingDays;
          }

          initialWorkingDays[emp.EmpId] = workingDays;
          initialWorkingHours[emp.EmpId] = Math.abs(emp.TotalWorkingHours);
        });
        setEditableWorkingDays(initialWorkingDays);
        setEditableWorkingHours(initialWorkingHours);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch payroll data");
        // No setloading here - handled in finally
      } finally {
        setloading(false); // Always hide spinner after try/catch
      }
    } else {
      setloading(false); // Early exit if no dates
    }
  };

  const handleEmployeeCheckboxChange = (employeeId) => {
    setSelectedEmployees((prev) => ({
      ...prev,
      [employeeId]: !prev[employeeId],
    }));
  };

  // Handler for unauthorize column checkboxes
  const handleEmployeeCheckboxChangeApproved = (employeeId) => {
    setSelectedEmployeesForUnauthorize((prev) => ({
      ...prev,
      [employeeId]: !prev[employeeId],
    }));
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setApproveall(checked);
    // Build new selection state
    const newSelections = { ...selectedEmployees };
    const eligibleEmployees = filteredPayrollData.filter(
      (emp) =>
        emp.NetSalary > 0 && emp.TotalAdditions > 0 && emp.IsChecked !== 1,
    );
    eligibleEmployees.forEach((emp) => {
      // check if this employee has a late deduction pending
      const isLateDeductionPending = DeductionData.find(
        (el) =>
          el.EmpId === emp.EmpId &&
          (el.DeductionStatus == null ||
            el.DeductionStatus == undefined ||
            el.DeductionStatus == 0),
      );

      if (!isLateDeductionPending) {
        newSelections[emp.EmpId] = checked; // only set if NOT pending
      } else {
        newSelections[emp.EmpId] = false; // keep unchecked
      }
    });

    setSelectedEmployees(newSelections);
  };

  // Handle Select All for Unauthorize column
  const handleSelectAllApproved = (e) => {
    const checked = e.target.checked;
    setUnauthorizeAllChecked(checked);

    // Filter employees who are eligible (IsChecked == 1)
    const eligibleEmployees = filteredPayrollData.filter(
      (emp) => emp.IsChecked === 1,
    );

    // Build new selection state
    const newSelections = { ...selectedEmployeesForUnauthorize };
    eligibleEmployees.forEach((emp) => {
      newSelections[emp.EmpId] = checked; // all true if checked, all false if unchecked
    });

    setSelectedEmployeesForUnauthorize(newSelections);
  };

  const handleViewClick = () => {
    fetchData(); // Existing function to fetch payroll data
    fetchdedution(); // Call the fetchdedution function to fetch deduction data
  };
  const handleAddAddition = () => {
    setAddition([...addition, { additionAmount: "", additionDescription: "" }]);
  };
  const handelChange = (empId, value) => {
    const updatedData = datafilter.map((el) =>
      el.EmpId === empId ? { ...el, Remark: value.target.value } : el,
    );
    setDataFilter(updatedData); // Assuming you're using setState to update datafilter
  };

  const handleAddaddtionChange = (index, field, value) => {
    // Parse value conditionally
    const parsedValue =
      field === "additionAmount" ? parseInt(value, 10) : value;

    // Update additions array
    const updatedAdditions = addition.map((item, i) =>
      i === index ? { ...item, [field]: parsedValue } : item,
    );

    // Find the employee with matching employeeId
    const updatedPayrollData = PayrollData.map((employee) => {
      if (employee?.EmpId === employeeId) {
        // Calculate difference in addition amount if this is an amount change
        const amountDifference =
          field === "additionAmount"
            ? parsedValue - addition[index].additionAmount
            : 0;

        // Update employee record with new total
        return {
          ...employee,
          TotalAdditions: employee?.TotalAdditions + amountDifference,
        };
      }
      return employee;
    });

    setAddition(updatedAdditions);
  };

  const handleRemoveAddition = (index) => {
    const updatedAdditions = addition.filter((_, i) => i !== index);
    setAddition(updatedAdditions);
  };

  const handleSaveAddition = () => {
    if (addition && Array.isArray(addition)) {
      // Step 1: Create new addition data + detect if Basic was edited
      const isBasicEdited = addition.some((add) =>
        add.additionDescription?.toLowerCase().includes("basic"),
      );
      const AdditionDataArray = addition
        .filter((addition) => Number(addition.additionAmount) > 0)
        .map((additionItem) => ({
          BaseAmount: additionItem.additionAmount,
          CalculatedAmount: additionItem.additionAmount,
          ComponentId: "Null",
          ComponentName: additionItem.additionDescription,
          ComponentType: "Addition type",
          EmpId: employeeId,
          PercentageValue: null,
          ValueType: "Fixed Amount",
          WageTypeId: null,
          WageTypeName: null,
        }));
      // Step 2: Update state + smart recalculation
      setAdditionsDeductions((prev) => {
        let updatedState = [...prev, ...AdditionDataArray];
        const employeeComponents = updatedState.filter(
          (item) => item.EmpId === employeeId,
        );

        // CASE 1: Basic was edited → Full cascade update (like processAllEmployees)
        if (isBasicEdited) {
          const basicComponent = employeeComponents.find(
            (el) =>
              el.ComponentName?.toLowerCase() === "basic" &&
              el.ComponentType?.toLowerCase() === "addition type",
          );

          if (basicComponent) {
            const employee = PayrollData.find((e) => e.EmpId === employeeId);
            if (employee) {
              const totalWorkingDays = employee.TotalWorkingDays;
              const totalempday =
                editableWorkingDays[employeeId] ??
                (employee.EmployeeTotalWorkingDays ?? 0) +
                  (employee.TotalLeaveDays ?? 0) +
                  (employee.TotalHalfDay_NOT_HalfDaysLOP_COUNT ?? 0) -
                  (employee.TotalHalfDay ?? 0) -
                  (employee.LateCut ?? 0);

              let basic = basicComponent.BaseAmount || 0;
              const updatedBasic =
                selectedOption === "Monthly" ? basic / totalWorkingDays : basic;
              const totalBasicForMonth =
                selectedOption === "Monthly"
                  ? employee.Id
                    ? Math.round(basic)
                    : Math.round(updatedBasic * totalempday)
                  : Math.round(updatedBasic * totalempday);

              // Update Basic CalculatedAmount
              updatedState = updatedState.map((el) =>
                el.EmpId === employeeId &&
                el.ComponentId === basicComponent.ComponentId
                  ? { ...el, CalculatedAmount: totalBasicForMonth }
                  : el,
              );

              // Update ALL basic-dependent components
              updatedState = updatedState.map((el) => {
                if (
                  el.EmpId === employeeId &&
                  el.WageTypeName?.toLowerCase()?.includes("basic") &&
                  el.PercentageValue &&
                  el.ComponentName?.toLowerCase() !== "basic"
                ) {
                  return {
                    ...el,
                    CalculatedAmount: Math.round(
                      (totalBasicForMonth * el.PercentageValue) / 100,
                    ),
                  };
                }
                return el;
              });
            }
          }
        }

        // CASE 2: ANY edited component → Update dependents + PF/ESI with 15k cap
        employeeComponents.forEach((component) => {
          if (
            component.PercentageValue &&
            component.ValueType?.includes("Percentage") &&
            (component.WageTypeName || component.WageComponentName)
          ) {
            const baseNamesString =
              component.WageTypeName || component.WageComponentName;
            const baseNames = baseNamesString.split("+");

            let totalBaseCalculated = 0;
            baseNames.forEach((baseName) => {
              const baseComponent = employeeComponents.find(
                (item) =>
                  item.ComponentName?.toLowerCase() ===
                  baseName.trim().toLowerCase(),
              );
              if (baseComponent) {
                totalBaseCalculated += baseComponent.CalculatedAmount || 0;
              }
            });

            // PF 15,000 CAP LOGIC
            let newBaseAmount = Math.round(totalBaseCalculated);
            if (component.ComponentName?.toLowerCase() === "pf") {
              newBaseAmount =
                totalBaseCalculated > 15000 ? 15000 : newBaseAmount;
            }

            const newCalculatedAmount = Math.round(
              (newBaseAmount * component.PercentageValue) / 100,
            );

            updatedState = updatedState.map((el) => {
              if (
                el.EmpId === employeeId &&
                el.ComponentId === component.ComponentId
              ) {
                return {
                  ...el,
                  BaseAmount: newBaseAmount,
                  CalculatedAmount: newCalculatedAmount,
                };
              }
              return el;
            });
          }
        });

        return updatedState;
      });
      toast.success("Additions saved Successfully");
      toggleAdditionsModal();
      setAddition([]);
    }
  };

  //------------------------Deductions----------------

  const handleAddDeduction = () => {
    setDeductions([...deductions, { amount: "", description: "" }]);
  };

  const handleDeductionChange = (index, field, value) => {
    const parsedValue = field === "amount" ? parseInt(value, 10) : value;
    const updatedDeductions = deductions.map((item, i) =>
      i === index ? { ...item, [field]: parsedValue } : item,
    );

    const updatedPayrollData = PayrollData.map((employee) => {
      if (employee?.EmpId === employeeId) {
        const amountDifferenceDeduct =
          field === "amount" ? parsedValue - deductions[index].amount : 0;

        //console.log(amountDifferenceDeduct, "gjgjhgjh");

        return {
          ...employee,
          TotalDeductions: employee?.TotalDeductions + amountDifferenceDeduct,
        };
      }
      return employee;
    });
    // setPayrollData(updatedPayrollData);
    setDeductions(updatedDeductions);
  };

  const handleRemoveDeduction = (index) => {
    const updatedDeductions = deductions.filter((_, i) => i !== index);
    setDeductions(updatedDeductions);
  };

  const handleUnAutherize = async () => {
    try {
      setloading(true);

      const selectedApprovedEmployees = filteredPayrollData
        .filter(
          (employee) =>
            selectedEmployeesForUnauthorize[employee?.EmpId] &&
            employee?.IsChecked === 1,
        )
        .map((employee) => ({
          UserId: UID || "",
          Id: employee?.Id || "",
        }));

      if (selectedApprovedEmployees.length === 0) {
        toast.error(
          "Please select at least one approved employee to unauthorize",
        );
        setloading(false);
        return;
      }

      // Validate reason
      if (!unApproveUser[0].Reason.trim()) {
        toast.error("Please provide a reason for unauthorizing");
        setloading(false);
        return;
      }

      const payload = {
        Reason: unApproveUser[0].Reason,
        UserId: UID,
      };

      // Optional: Call InsertDuty if needed for logging the reason
      const response = await InsertUnAutherisePayrollUserDetails(payload);

      if (response.data.recordset[0].StatusCode == 200) {
        const unAuthResponse = await UnAuthorizePayroll(
          selectedApprovedEmployees,
        );
        if (unAuthResponse.status == 201) {
          toast.success("Payroll unauthorized successfully");
          setSelectedEmployeesForUnauthorize({}); // Clear selections
          setUnApproveUser([{ Reason: "", UserId: "" }]); // Reset reason
          fetchData(); // Refresh data
          setUnApproveModal(false);
          setFilterMethod("");
          setUnauthorizeAllChecked(false);
        } else {
          toast.error("Failed to unauthorize selected employees");
        }
      } else {
        toast.error("Failed to record unapprove reason");
      }
    } catch (error) {
      console.error("Error during unauthorized handling:", error);
      toast.error("Failed to unauthorize payroll. Please try again.");
    } finally {
      setloading(false);
    }
  };

  const handleopenunAutherisemodal = () => {
    const selectedApprovedEmployees = filteredPayrollData.filter(
      (employee) =>
        selectedEmployeesForUnauthorize[employee?.EmpId] &&
        employee?.IsChecked === 1,
    );

    if (selectedApprovedEmployees.length === 0) {
      toast.error(
        "Please select at least one approved employee to unauthorize",
      );
      return;
    }

    setUnApproveModal(true);
  };

  const handlecloseUnapproveModal = () => {
    setUnApproveModal(false);
  };

  const handleSave = () => {
    if (deductions && Array.isArray(deductions)) {
      // Map multiple deductions to an array of ExtraDeductions objects
      const ExtraDeductionsArray = deductions
        .filter((deduction) => Number(deduction.amount) > 0)
        .map((deduction) => ({
          BaseAmount: deduction.amount,
          CalculatedAmount: deduction.amount,
          ComponentId: "Null",
          ComponentName: deduction.description,
          ComponentType: "Deduction type",
          EmpId: employeeId,
          PercentageValue: null,
          ValueType: "Fixed Amount",
          WageTypeId: null,
          WageTypeName: null,
        }));

      //console.log(ExtraDeductionsArray, "ghdghdgshgd");

      // Update the state 'additionsDeductions' to include all new deductions
      setAdditionsDeductions((prev) => [...prev, ...ExtraDeductionsArray]);
      toast.success("Deductions Saved Successfully");
      toggleDeductionsModal(); // Close the modal after saving
      setDeductions([]); // Clear the deductions state
    } else {
      //console.log("No deductions to save.");
    }
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    // Reset dates when option changes
    if (selectedValue == "Monthly") {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // Note: getMonth() returns 0-11

      // First day of the month
      const firstDay = new Date(year, month, 2);
      const formattedFirstDay = firstDay.toISOString().split("T")[0];

      // Last day of the month
      const lastDay = new Date(year, month + 1, 1); // 0th day of next month = last day of current month
      const formattedLastDay = lastDay.toISOString().split("T")[0];

      setFromDate(formattedFirstDay);
      setToDate(formattedLastDay);

      const formattedMonth = String(month + 1).padStart(2, "0");
      setSelectedMonth(`${year}-${formattedMonth}`);
      handleMonthChange({ target: { value: `${year}-${formattedMonth}` } });
    } else {
      // For daily/weekly, default to today's date
      const today = new Date().toISOString().split("T")[0];
      setFromDate(today);
      setToDate(today);
      setSelectedMonth(""); // Clear month selection
    }
  };

  const toggleAdditionsModal = (Id) => {
    if (isAdditionsModalOpen) {
      // Reset states when closing the modal
      setAddition([]); // Clear addition inputs
      setEditAdditionIndex(null); // Clear edit mode for additions
      setEditAdditionAmount(""); // Clear edit amount
      setEmployeeId(null); // Clear employee ID
    } else {
      // Set new employee ID and reset states when opening the modal
      setEmployeeId(Id);
      setAddition([]); // Clear addition inputs
      setEditAdditionIndex(null); // Clear edit mode
      setEditAdditionAmount(""); // Clear edit amount
    }
    setAdditionsModalOpen(!isAdditionsModalOpen); // Toggle modal visibility
  };

  const toggleDeductionsModal = (Id) => {
    if (isDeductionsModalOpen) {
      // Reset states when closing the modal
      setDeductions([]); // Clear deduction inputs
      setEditDeductionIndex(null); // Clear edit mode for deductions
      setEditDeductionAmount(""); // Clear edit amount
      setEmployeeId(null); // Clear employee ID
    } else {
      // Set new employee ID and reset states when opening the modal
      setEmployeeId(Id);
      setDeductions([]); // Clear deduction inputs
      setEditDeductionIndex(null); // Clear edit mode
      setEditDeductionAmount(""); // Clear edit amount
    }
    setDeductionsModalOpen(!isDeductionsModalOpen); // Toggle modal visibility
  };

  const payrollTotals = useMemo(() => {
    const result = {};

    PayrollData.forEach((employee) => {
      const empId = employee?.EmpId;
      const isChecked = employee?.IsChecked == 1;

      /* ================= ADDITIONS ================= */
      const totalAdditions = isChecked
        ? Math.round(Number(employee?.TotalAdditions || 0))
        : Math.round(
            additionsDeductions
              .filter(
                (l) =>
                  l.EmpId === empId &&
                  (l.ComponentType === "Addition type" ||
                    l.ComponentType === "Addition"),
              )
              .reduce((total, AD) => {
                const amount =
                  AD.ValueType === "Percentage"
                    ? (Number(AD.BaseAmount || 0) *
                        Number(AD.PercentageValue || 0)) /
                      100
                    : Number(AD.CalculatedAmount || 0);

                return total + (isNaN(amount) ? 0 : Math.round(amount));
              }, 0),
          );

      /* ================= DEDUCTIONS ================= */
      const totalDeductions = isChecked
        ? Math.round(Number(employee?.TotalDeductions || 0))
        : Math.round(
            additionsDeductions
              .filter(
                (l) =>
                  l.EmpId === empId &&
                  (l.ComponentType === "Deduction type" ||
                    l.ComponentType === "Deduction"),
              )
              .reduce((total, AD, _, fullList) => {
                // ❌ Skip DA
                if (AD.ComponentName?.toLowerCase() === "da") return total;

                // ❌ Skip Nested % if Percentage exists with BaseAmount > 15000
                if (
                  AD.ValueType === "Nested Percentage" &&
                  fullList.some(
                    (other) =>
                      other.ComponentId === AD.ComponentId &&
                      other.ValueType === "Percentage" &&
                      Number(other.BaseAmount) > 15000,
                  )
                ) {
                  return total;
                }

                let amount = 0;
                const isESI = AD.ComponentName?.toLowerCase() === "esi";

                if (AD.ValueType === "Percentage") {
                  const baseAmount = Number(AD.BaseAmount || 0);
                  const cappedBase = isESI
                    ? baseAmount
                    : baseAmount > 15000
                      ? 15000
                      : baseAmount;

                  amount = (cappedBase * Number(AD.PercentageValue || 0)) / 100;
                } else {
                  amount = Number(AD.CalculatedAmount || 0);
                }

                return total + (isNaN(amount) ? 0 : Math.round(amount));
              }, 0),
          );

      /* ================= NET ================= */
      const netTotal = totalAdditions - totalDeductions;

      result[empId] = {
        totalAdditions,
        totalDeductions,
        netTotal,
      };
    });

    return result;
  }, [PayrollData, additionsDeductions]);

  const calculateTotalByType = ({ list, empId, type }) => {
    return Math.round(
      list
        .filter(
          (l) =>
            l.EmpId === empId &&
            (l.ComponentType === `${type} type` || l.ComponentType === type),
        )
        .reduce((total, AD, _, fullList) => {
          /* -------- Deduction-specific rules -------- */
          if (type === "Deduction") {
            if (AD.ComponentName?.toLowerCase() === "da") return total;

            if (
              AD.ValueType === "Nested Percentage" &&
              fullList.some(
                (other) =>
                  other.ComponentId === AD.ComponentId &&
                  other.ValueType === "Percentage" &&
                  Number(other.BaseAmount) > 15000,
              )
            ) {
              return total;
            }
          }

          /* -------- Amount calculation -------- */
          let amount = 0;

          if (AD.ValueType === "Percentage") {
            const base = Number(AD.BaseAmount || 0);
            const percent = Number(AD.PercentageValue || 0);

            if (type === "Deduction") {
              const isESI = AD.ComponentName?.toLowerCase() === "esi";
              const cappedBase = isESI ? base : Math.min(base, 15000);
              amount = (cappedBase * percent) / 100;
            } else {
              amount = (base * percent) / 100;
            }
          } else {
            amount = Number(AD.CalculatedAmount || 0);
          }

          return total + (isNaN(amount) ? 0 : Math.round(amount));
        }, 0),
    );
  };

  const footerTotalAdditions = useMemo(
    () =>
      calculateTotalByType({
        list: additionsDeductions,
        empId: employeeId,
        type: "Addition",
      }),
    [additionsDeductions, employeeId],
  );

  const footerTotalDeductions = useMemo(
    () =>
      calculateTotalByType({
        list: additionsDeductions,
        empId: employeeId,
        type: "Deduction",
      }),
    [additionsDeductions, employeeId],
  );

  const handleWorkingDaysEdit = (empId) => {
    // Enable editing for this specific employee
    setEditingEmployees((prev) => ({
      ...prev,
      [empId]: true,
    }));
  };
  const handleWorkingDaysChange = (empId, value) => {
    // Update the temporary working days value
    setEditableWorkingDays((prev) => ({
      ...prev,
      [empId]: value === "" ? "" : parseFloat(value),
    }));
  };

  useEffect(() => {
    console.log(filteredPayrollData, "asdasdas");
  }, [filteredPayrollData]);

  const handleWorkingDaysSubmit = (empId, Total, PLeave) => {
    // Step 1-9 remain exactly the same (Basic, Nested %, PF logic)
    const employee = PayrollData.find((emp) => emp.EmpId === empId);
    if (!employee) {
      console.error(`Employee with EmpId ${empId} not found in PayrollData`);
      return;
    }

    const value = editableWorkingDays[empId] ?? Total ?? 0;
    if (value < 0) {
      console.error(`Invalid working days for EmpId ${empId}: ${value}`);
      return;
    }

    const basicComponent = additionsDeductions
      ?.filter((el) => el.EmpId === empId)
      ?.find((el) => el.WageTypeName?.toLowerCase() === "basic");

    const Basic = basicComponent?.BaseAmount || 0;
    const updatedBasic =
      selectedOption === "Monthly" && Total > 0 ? Basic / Total : Basic;

    const count =
      (value || 0) +
      (PLeave || 0) +
      (employee?.TotalHalfDay ?? 0) -
      (employee?.LateCut ?? 0) -
      (employee?.SickCut ?? 0);

    const total = Math.round(updatedBasic * count);

    let tempAdditionsDeductions =
      additionsDeductions?.map((el) => {
        if (
          el?.EmpId === empId &&
          el?.WageTypeName?.toLowerCase() === "basic" &&
          !el.PercentageValue
        ) {
          return {
            ...el,
            CalculatedAmount: total,
          };
        } else if (
          el?.EmpId === empId &&
          el?.WageTypeName?.toLowerCase() === "basic" &&
          el.PercentageValue
        ) {
          return {
            ...el,
            BaseAmount: total,
          };
        }
        return el;
      }) || [];

    // Group and process Nested Percentage Deductions (Step 7-8 - unchanged)
    const deductionsByComponentId = {};
    tempAdditionsDeductions.forEach((deduction) => {
      if (deduction.EmpId === empId) {
        if (!deductionsByComponentId[deduction.ComponentId]) {
          deductionsByComponentId[deduction.ComponentId] = [];
        }
        deductionsByComponentId[deduction.ComponentId].push(deduction);
      }
    });

    Object.keys(deductionsByComponentId).forEach((componentId) => {
      const componentDeductions = deductionsByComponentId[componentId];
      const nestedPercentageItem = componentDeductions.find(
        (item) => item.ValueType === "Nested Percentage",
      );

      if (nestedPercentageItem) {
        const percentageItem = componentDeductions.find(
          (item) => item.ValueType === "Percentage",
        );

        if (percentageItem) {
          const firstLevelPercentage =
            (nestedPercentageItem.BaseAmount *
              nestedPercentageItem.PercentageValue) /
            100;
          const nestedCalculatedAmount =
            (firstLevelPercentage * percentageItem.PercentageValue) / 100;

          tempAdditionsDeductions = tempAdditionsDeductions.map((item) => {
            if (
              item.EmpId === empId &&
              item.ComponentId === nestedPercentageItem.ComponentId &&
              item.ValueType === "Nested Percentage"
            ) {
              return {
                ...item,
                CalculatedAmount: Math.round(nestedCalculatedAmount),
              };
            }
            return item;
          });
        }
      }
    });

    // PF Calculation (Step 9 - unchanged)
    const basic = tempAdditionsDeductions.find(
      (a) =>
        a.EmpId === empId &&
        a.ComponentName?.toLowerCase() === "basic" &&
        a.ComponentType?.toLowerCase().includes("addition"),
    );

    const da = tempAdditionsDeductions.find(
      (a) =>
        a.EmpId === empId &&
        a.ComponentName?.toLowerCase() === "da" &&
        a.ComponentType?.toLowerCase().includes("addition"),
    );

    const daPercentage = da ? Number(da.PercentageValue || 0) : 0;
    const basicAmount = basic?.CalculatedAmount || 0;
    const daAmount = (basicAmount * daPercentage) / 100;
    const newBaseForPF = basicAmount + daAmount;

    tempAdditionsDeductions = tempAdditionsDeductions.map((item) => {
      const isPF =
        item.EmpId === empId &&
        item.ComponentName?.toLowerCase() === "pf" &&
        item.ComponentType?.toLowerCase().includes("deduction") &&
        item.ValueType?.trim().toLowerCase() === "percentage";

      if (isPF) {
        const pfPercentage = Number(item.PercentageValue || 0);
        const calculatedPF = (newBaseForPF * pfPercentage) / 100;
        return {
          ...item,
          BaseAmount: Math.round(newBaseForPF),
          CalculatedAmount: Math.round(calculatedPF),
        };
      }
      return item;
    });

    // 🔥 NEW: ESI Calculation (following exact processAllEmployees logic)
    const EsiBasic = tempAdditionsDeductions.find(
      (a) =>
        a.EmpId === empId &&
        a.ComponentName?.toLowerCase() === "basic" &&
        a.ComponentType?.toLowerCase().includes("addition"),
    );

    const EsiDA = tempAdditionsDeductions.find(
      (a) =>
        a.EmpId === empId &&
        a.ComponentName?.toLowerCase() === "da" &&
        a.ComponentType?.toLowerCase().includes("addition"),
    );

    const EsiPercentage = EsiDA ? Number(EsiDA.PercentageValue || 0) : 0;
    const basicAmountEsi = EsiBasic?.CalculatedAmount || 0;
    const daAmountEsi = Math.round(basicAmountEsi * EsiPercentage) / 100;
    const newBaseForEsi = Math.round(basicAmountEsi + daAmountEsi);

    tempAdditionsDeductions = tempAdditionsDeductions.map((item) => {
      const isESI =
        item.EmpId === empId &&
        item.ComponentName?.toLowerCase() === "esi" &&
        item.ComponentType?.toLowerCase().includes("deduction") &&
        item.ValueType?.trim().toLowerCase() === "percentage";

      if (isESI) {
        const esiNewPercentage = Number(item.PercentageValue || 0);
        const calculatedEsi = (newBaseForEsi * esiNewPercentage) / 100;
        return {
          ...item,
          BaseAmount: Math.round(newBaseForEsi),
          CalculatedAmount: Math.round(calculatedEsi),
        };
      }
      return item;
    });

    // Step 10: Save updated data to state
    setAdditionsDeductions(tempAdditionsDeductions);

    // Step 11: Disable editing
    setEditingEmployees((prev) => ({
      ...prev,
      [empId]: false,
    }));
  };

  const SalaryBreakdownModal = ({
    isOpen,
    onClose,
    employee,
    editableWorkingDays,
    additionsDeductions,
  }) => {
    if (!isOpen || !employee) return null;

    const workingDays =
      editableWorkingDays[employee?.EmpId] ?? employee?.TotalWorkingDays ?? 0;

    // ✅ Find Basic Component
    const basicComponent = additionsDeductions
      ?.filter((el) => el.EmpId === employee?.EmpId)
      ?.find(
        (el) =>
          el.WageTypeName?.toLowerCase() === "basic" &&
          el.ComponentName?.toLowerCase() === "basic",
      );

    const totalBasic = Math.round(Number(basicComponent?.BaseAmount ?? 0));

    // ✅ Total Additions
    const totalAdditions =
      employee?.IsChecked == 1
        ? Math.round(Number(employee?.TotalAdditions || 0))
        : calculateTotalByType({
            list: additionsDeductions,
            empId: employee?.EmpId,
            type: "Addition",
          });

    // ✅ Total Deductions
    const totalDeductions =
      employee?.IsChecked == 1
        ? Math.round(Number(employee?.TotalDeductions || 0))
        : calculateTotalByType({
            list: additionsDeductions,
            empId: employee?.EmpId,
            type: "Deduction",
          });

    // ✅ Net Total
    const netTotal = totalAdditions - totalDeductions;

    console.log(netTotal, "dajksds");

    return (
      <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <h3 className="text-lg font-bold mb-4">
            Salary Breakdown for {employee?.Name}
          </h3>

          <div className="space-y-3">
            <div className="flex justify-between font-medium">
              <span>Total Basic Amount:</span>
              <span>₹{totalBasic}</span>
            </div>
            <div className="border-t pt-2 flex justify-between text-green-600">
              <span>Total Additions:</span>
              <span>+₹{totalAdditions}</span>
            </div>
            <div className="flex justify-between text-red-600">
              <span>Total Deductions:</span>
              <span>-₹{totalDeductions}</span>
            </div>
            <div className="border-t pt-2 flex justify-between font-bold">
              <span>Net Total:</span>
              <span>₹{netTotal}</span>
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Add these states and functions to your component

  const toggleBreakdownModal = (employeeId) => {
    setSelectedEmployeeId(employeeId);
    setBreakdownModalOpen(true);
  };

  const closeBreakdownModal = () => {
    setBreakdownModalOpen(false);
    setSelectedEmployeeId(null);
  };

  const handleWorkingHoursChange = (empId, value) => {
    setEditableWorkingHours((prev) => ({
      ...prev,
      [empId]: parseInt(value, 10),
    }));
  };

  const handleApprovePayrole = async () => {
    if (loading) {
      return;
    }

    if (!Object.values(selectedEmployees).some(Boolean)) {
      toast.error("Please select at least one employee");
      return;
    }

    setloading(true);

    try {
      const payload = datafilter
        .filter((employee) => selectedEmployees[employee?.EmpId])
        .map((employee) => {
          const workingDays =
            editableWorkingDays[employee?.EmpId] || employee?.TotalWorkingDays;
          const workingHours =
            editableWorkingHours[employee?.EmpId] ||
            Math.abs(employee?.TotalWorkingHours);

          const employeeAdditions = additionsDeductions.filter(
            (ad) =>
              ad.EmpId === employee?.EmpId &&
              (ad.ComponentType === "Addition type" ||
                ad.ComponentType === "Addition"),
          );

          const employeeDeductions = additionsDeductions
            .filter(
              (ad) =>
                ad.EmpId === employee?.EmpId &&
                (ad.ComponentType === "Deduction type" ||
                  ad.ComponentType === "Deduction"),
            )
            .filter((ad, _, fullList) => {
              // Skip DA from deductions
              if (ad.ComponentName?.toLowerCase() === "da") return false;

              if (ad.ValueType === "Nested Percentage") {
                const hasMainPercentage = fullList.some(
                  (other) =>
                    other.ComponentId === ad.ComponentId &&
                    other.ValueType === "Percentage" &&
                    Number(other.BaseAmount) > 15000,
                );
                return !hasMainPercentage;
              }
              return true;
            });

          // Calculate Total Additions (aligned with table)
          const TotalCalculatedAddition = Math.round(
            employeeAdditions.reduce((total, AD) => {
              const amount =
                AD.ValueType === "Percentage"
                  ? (Number(AD.BaseAmount) * Number(AD.PercentageValue || 0)) /
                    100
                  : Number(AD.CalculatedAmount || 0);
              return total + (isNaN(amount) ? 0 : Math.round(amount));
            }, 0),
          );

          // Calculate Total Deductions with ESI logic (aligned with table)
          const TotalCalculatedDeduction = Math.round(
            employeeDeductions.reduce((total, AD, _, fullList) => {
              // Skip DA
              if (AD.ComponentName?.toLowerCase() === "da") return total;

              if (
                AD.ValueType === "Nested Percentage" &&
                fullList.some(
                  (other) =>
                    other.ComponentId === AD.ComponentId &&
                    other.ValueType === "Percentage" &&
                    Number(other.BaseAmount) > 15000,
                )
              ) {
                return total;
              }

              let amount = 0;
              const isESI = AD.ComponentName?.toLowerCase() === "esi";

              if (AD.ValueType === "Percentage") {
                const baseAmount = Number(AD.BaseAmount || 0);

                // ✅ ESI: No ceiling, use exact BaseAmount
                // ✅ PF and others: Apply 15000 ceiling
                const cappedBase = isESI
                  ? baseAmount
                  : baseAmount > 15000
                    ? 15000
                    : baseAmount;

                amount = (cappedBase * Number(AD.PercentageValue || 0)) / 100;
              } else {
                amount = Number(AD.CalculatedAmount || 0);
              }
              return total + (isNaN(amount) ? 0 : Math.round(amount));
            }, 0),
          );

          // Calculate NetSalary (aligned with table)
          const NetSalary = Math.round(
            TotalCalculatedAddition - TotalCalculatedDeduction,
          );

          const basicComponent = additionsDeductions.find(
            (el) =>
              el.EmpId === employee?.EmpId &&
              el.WageTypeName?.toLowerCase() === "basic" &&
              el.ComponentName?.toLowerCase() === "basic",
          );

          const CurrentBasicPay = Number(
            basicComponent?.BaseAmount || 0,
          ).toFixed(2);

          return {
            UserId: UID,
            Id: "",
            VoucherNo: 0,
            employeeId: employee?.EmpId,
            isChecked: 2,
            selectedOption,
            fromDate,
            toDate,
            ...employee,
            CurrentBasicPay: CurrentBasicPay || 0,
            EmployeeTotalWorkingDays:
              editableWorkingDays[employee?.EmpId] ??
              employee?.EmployeeTotalWorkingDays,
            payrolldays:
              editableWorkingDays[employee?.EmpId] != null
                ? (editableWorkingDays[employee?.EmpId] ?? 0) +
                  (employee?.TotalLeaveDays ?? 0) +
                  (employee?.TotalHalfDay ?? 0) -
                  (employee?.LateCut ?? 0)
                : (employee?.EmployeeTotalWorkingDays ?? 0) +
                  (employee?.TotalLeaveDays ?? 0) +
                  (employee?.TotalHalfDay ?? 0) -
                  (employee?.LateCut ?? 0),

            TotalAdditions: TotalCalculatedAddition,
            TotalDeductions: TotalCalculatedDeduction,
            additions: employeeAdditions,
            deductions: employeeDeductions.map((ad) => {
              const isESI = ad.ComponentName?.toLowerCase() === "esi";

              return {
                ...ad,
                CalculatedAmount:
                  ad.ValueType === "Percentage"
                    ? Number(
                        (
                          (Number(
                            isESI
                              ? ad.BaseAmount // ESI: Use exact base
                              : ad.BaseAmount > 15000
                                ? 15000 // PF: Apply ceiling
                                : ad.BaseAmount,
                          ) *
                            Number(ad.PercentageValue || 0)) /
                          100
                        ).toFixed(2),
                      )
                    : Number(ad.CalculatedAmount || 0).toFixed(2),
              };
            }),
            Remark: employee?.Remark || "",
            NetSalary,
          };
        });

      if (payload.length === 0) {
        toast.error("Please select at least one employee to approve");
        return;
      }

      const response = await insertEmpPayrollData(payload);
      if (response.data.message) {
        toast.success("Payroll approved successfully");
        fetchData();
      }
    } catch (error) {
      console.error("Error approving payroll:", error);
      toast.error(
        "An error occurred while approving the payroll. Please try again.",
      );
    } finally {
      setloading(false);
    }
  };

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    setSelectedMonth(selectedMonth);

    if (selectedOption === "Monthly") {
      const [year, month] = selectedMonth.split("-");
      const firstDate = new Date(parseInt(year), parseInt(month) - 1, 1);
      const lastDate = new Date(parseInt(year), parseInt(month), 0);

      // Format dates with leading zeros if needed
      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      };

      setFromDate(formatDate(firstDate));
      setToDate(formatDate(lastDate));
    }
  };

  const handleDeleteDeduction = (index) => {
    //console.log(index, "Deduction delete index");
    // Filter deductions specifically
    let data = additionsDeductions.filter(
      (l) =>
        l.EmpId === employeeId &&
        (l.ComponentType === "Deduction type" ||
          l.ComponentType === "Deduction"),
    );

    // Remove the specific item at `index` in the filtered deductions
    data.splice(index, 1);

    // Update state with the updated deductions array
    setAdditionsDeductions((prev) => {
      const updatedArray = prev.filter(
        (l) =>
          !(
            l.EmpId === employeeId &&
            (l.ComponentType === "Deduction type" ||
              l.ComponentType === "Deduction")
          ),
      );

      // Combine updated filtered array with the rest of the original state
      const finalArray = [...updatedArray, ...data];

      return finalArray;
    });
  };

  const handleDelete = (index) => {
    //console.log(index, "asddsas");
    let data = additionsDeductions.filter(
      (l) =>
        l.EmpId === employeeId &&
        (l.ComponentType === "Addition type" || l.ComponentType === "Addition"),
    );
    // Remove the specific item from `data` where `index` matches
    data.splice(index, 1);
    setAdditionsDeductions((prev) => {
      const updatedArray = prev.filter(
        (l) =>
          !(
            l.EmpId === employeeId &&
            (l.ComponentType === "Addition type" ||
              l.ComponentType === "Addition")
          ),
      );

      const finalArray = [...updatedArray, ...data];
      //console.log(finalArray, "Updated additionsDeductions");

      return finalArray;
    });
  };

  const handleFilterChange = (selectedMethod, selectedOptionName) => {
    //console.log(selectedMethod, "Selected Method", selectedOptionName);

    setFilterMethod(selectedMethod);

    // Clone the original PayrollData to start filtering
    let filteredData = [...PayrollData];

    // Apply filtering based on the selected method
    if (selectedMethod === "DepartmentID") {
      filteredData = filteredData?.filter(
        (item) => item.DepartmentName === selectedOptionName,
      );
    } else if (selectedMethod === "DesignationId") {
      filteredData = filteredData?.filter(
        (item) => item.DesignationName === selectedOptionName,
      );
    } else if (selectedMethod === "ProfitCenterID") {
      filteredData = filteredData?.filter(
        (item) => item.ProfitcenterName === selectedOptionName,
      );
    } else if (selectedMethod === "CategoryId") {
      filteredData = filteredData?.filter(
        (item) => item.CategoryName === selectedOptionName,
      );
    } else if (selectedMethod === "GroupId") {
      filteredData = filteredData?.filter(
        (item) => item.GroupName === selectedOptionName,
      );
    }
    setDataFilter(filteredData);
    //console.log("Filtered Data:", filteredData);
  };

  const handleClearFilter = () => {
    setFilterMethod(""); // Clear the selected filter method
    setDataFilter(PayrollData); // Reset to the original unfiltered data
    //console.log("Filters cleared. Showing all data.");
  };

  const handleDateChange = (type, value) => {
    if (type === "from") {
      setFromDate(value);
    } else {
      setToDate(value);
    }
  };

  // Inside your component
  const deductionRows = additionsDeductions
    .filter(
      (l) =>
        l.EmpId === employeeId &&
        (l.ComponentType === "Deduction type" ||
          l.ComponentType === "Deduction"),
    )
    .reduce((acc, item) => {
      const existingItem = acc.find((x) => x.ComponentId === item.ComponentId);

      if (existingItem) {
        const mainComponent =
          existingItem.ValueType === "Percentage" ? existingItem : item;
        const nestedComponent =
          existingItem.ValueType === "Nested Percentage" ? existingItem : item;

        const baseAmount = Number(mainComponent.BaseAmount);
        const mainPercent = parseFloat(mainComponent.PercentageValue);
        const nestedPercent = parseFloat(nestedComponent.PercentageValue);

        const mainCalc = (mainPercent / 100) * baseAmount;
        const nestedBase = (nestedPercent / 100) * baseAmount;
        const nestedCalc = (mainPercent / 100) * nestedBase;

        existingItem.CalculatedAmount = mainCalc + nestedCalc;
        existingItem.displayName = `${mainComponent.ComponentName} (${mainComponent.WageTypeName}+${nestedComponent.ComponentName})`;
        existingItem.isComposite = true;
      } else {
        acc.push({
          ...item,
          displayName: item.ComponentName,
          isComposite: false,
          CalculatedAmount: item.CalculatedAmount || 0,
        });
      }

      return acc;
    }, []);

  const handleSaveAdditionEdit = (index) => {
    if (!editAdditionAmount || isNaN(editAdditionAmount)) {
      toast.error("Please enter a valid amount");
      return;
    }

    setAdditionsDeductions((prev) => {
      const additions = prev.filter(
        (l) =>
          l.EmpId === employeeId &&
          (l.ComponentType === "Addition type" ||
            l.ComponentType === "Addition"),
      );

      const originalAddition = additions[index];
      if (!originalAddition) {
        console.error("Addition not found at index:", index);
        return prev;
      }

      const editAmount = Number(editAdditionAmount);
      const isEditedBasic =
        originalAddition.ComponentName.toLowerCase() === "basic";

      // Step 1: Update the edited addition
      let updatedState = prev.map((item) => {
        if (item === originalAddition) {
          // Check if this is a percentage-based component
          const isPercentageType = originalAddition.ValueType?.trim()
            .toLowerCase()
            .includes("percentage");

          if (isPercentageType && originalAddition.PercentageValue) {
            // REVERSE CALCULATE: BaseAmount = (CalculatedAmount × 100) / Percentage
            const percentage = Number(originalAddition.PercentageValue);
            const newBaseAmount =
              percentage !== 0 ? (editAmount * 100) / percentage : 0;

            return {
              ...item,
              BaseAmount: Number(newBaseAmount.toFixed(2)),
              CalculatedAmount: editAmount,
            };
          } else {
            // For fixed amount components, BaseAmount = CalculatedAmount
            return {
              ...item,
              // BaseAmount: editAmount,
              CalculatedAmount: editAmount,
            };
          }
        }
        return item;
      });

      // Step 2: If BASIC was edited, update ALL components that depend on it
      if (isEditedBasic) {
        const employeeComponents = updatedState.filter(
          (item) => item.EmpId === employeeId,
        );

        employeeComponents.forEach((component) => {
          // Update components that have WageTypeName or WageComponentName
          if (
            component.PercentageValue &&
            component.ValueType?.includes("Percentage") &&
            (component.WageTypeName || component.WageComponentName) &&
            component.ComponentId !== originalAddition.ComponentId
          ) {
            const baseNamesString =
              component.WageTypeName || component.WageComponentName;
            const baseNames = baseNamesString.split("+");

            // Check if this component depends on BASIC
            const dependsOnBasic = baseNames.some(
              (name) => name.trim().toLowerCase() === "basic",
            );

            if (dependsOnBasic) {
              let totalBaseCalculated = 0;
              baseNames.forEach((baseName) => {
                const baseComponent = updatedState.find(
                  (item) =>
                    item.EmpId === employeeId &&
                    item.ComponentName?.toLowerCase() ===
                      baseName.trim().toLowerCase(),
                );
                if (baseComponent) {
                  totalBaseCalculated += baseComponent.CalculatedAmount || 0;
                }
              });

              const newBaseAmount = Math.round(totalBaseCalculated);
              const newCalculatedAmount = Math.round(
                (newBaseAmount * component.PercentageValue) / 100,
              );

              updatedState = updatedState.map((el) => {
                if (
                  el.EmpId === employeeId &&
                  el.ComponentId === component.ComponentId
                ) {
                  return {
                    ...el,
                    BaseAmount: newBaseAmount,
                    CalculatedAmount: newCalculatedAmount,
                  };
                }
                return el;
              });
            }
          }
        });
      }

      // Step 3: Get ALL addition components dynamically for deduction calculations
      const employeeAdditions = updatedState.filter(
        (item) =>
          item.EmpId === employeeId &&
          (item.ComponentType === "Addition type" ||
            item.ComponentType === "Addition"),
      );

      // Step 4: Recalculate ALL deductions based on their dependencies
      const employeeDeductions = updatedState.filter(
        (item) =>
          item.EmpId === employeeId &&
          (item.ComponentType === "Deduction type" ||
            item.ComponentType === "Deduction") &&
          item.PercentageValue &&
          item.ValueType?.toLowerCase().includes("percentage") &&
          (item.WageTypeName || item.WageComponentName),
      );

      employeeDeductions.forEach((deduction) => {
        const baseNamesString =
          deduction.WageTypeName || deduction.WageComponentName;
        const baseNames = baseNamesString.split("+");

        let totalBaseCalculated = 0;
        baseNames.forEach((baseName) => {
          const baseComponent = employeeAdditions.find(
            (item) =>
              item.ComponentName?.toLowerCase() ===
              baseName.trim().toLowerCase(),
          );
          if (baseComponent) {
            totalBaseCalculated += baseComponent.CalculatedAmount || 0;
          }
        });

        // Apply 15k cap for PF specifically
        let newBaseAmount = Math.round(totalBaseCalculated);
        if (
          deduction.ComponentName?.toLowerCase() === "pf" &&
          newBaseAmount > 15000
        ) {
          newBaseAmount = 15000;
        }

        const deductionPercentage = Number(deduction.PercentageValue || 0);
        const newCalculatedAmount = Math.round(
          (newBaseAmount * deductionPercentage) / 100,
        );

        updatedState = updatedState.map((item) => {
          if (
            item.EmpId === employeeId &&
            item.ComponentId === deduction.ComponentId
          ) {
            return {
              ...item,
              BaseAmount: newBaseAmount,
              CalculatedAmount: newCalculatedAmount,
            };
          }
          return item;
        });
      });

      return updatedState;
    });

    // Reset state
    setEditAdditionIndex(null);
    setEditAdditionAmount("");
  };

  const handleSaveDeductionEdit = (index) => {
    if (!editDeductionAmount || isNaN(editDeductionAmount)) {
      toast.error("Please enter a valid amount");
      return;
    }

    setAdditionsDeductions((prev) => {
      const deductions = prev.filter(
        (l) =>
          l.EmpId === employeeId &&
          (l.ComponentType === "Deduction type" ||
            l.ComponentType === "Deduction"),
      );

      const originalDeduction = deductions[index];
      if (!originalDeduction) {
        console.error("Deduction not found at index:", index);
        return prev;
      }

      const editAmount = Number(editDeductionAmount);

      // STEP 1: Update the edited deduction with reverse calculation
      let updatedState = prev.map((item) => {
        if (item === originalDeduction) {
          const isPercentageType = item.ValueType?.trim()
            .toLowerCase()
            .includes("percentage");

          if (isPercentageType && item.PercentageValue) {
            // REVERSE CALCULATE: BaseAmount = (CalculatedAmount × 100) / Percentage
            const percentage = Number(item.PercentageValue);
            const newBaseAmount =
              percentage !== 0 ? (editAmount * 100) / percentage : 0;

            return {
              ...item,
              BaseAmount: Math.round(newBaseAmount),
              CalculatedAmount: editAmount,
            };
          } else {
            // For fixed amount components
            return {
              ...item,
              BaseAmount: editAmount,
              CalculatedAmount: editAmount,
            };
          }
        }
        return item;
      });

      // STEP 2: Recalculate ALL other additions that depend on the edited deduction
      // (Rare case: if any addition depends on a deduction)
      const employeeComponents = updatedState.filter(
        (item) => item.EmpId === employeeId,
      );

      employeeComponents.forEach((component) => {
        // Skip the component we just edited
        if (component.ComponentId === originalDeduction.ComponentId) {
          return;
        }

        // Update components that have dependencies
        if (
          component.PercentageValue &&
          component.ValueType?.includes("Percentage") &&
          (component.WageTypeName || component.WageComponentName)
        ) {
          const baseNamesString =
            component.WageTypeName || component.WageComponentName;
          const baseNames = baseNamesString.split("+");

          // Check if this component depends on the edited deduction
          const dependsOnEditedDeduction = baseNames.some(
            (name) =>
              name.trim().toLowerCase() ===
              originalDeduction.ComponentName.toLowerCase(),
          );

          if (dependsOnEditedDeduction) {
            let totalBaseCalculated = 0;

            baseNames.forEach((baseName) => {
              const baseComponent = updatedState.find(
                (item) =>
                  item.EmpId === employeeId &&
                  item.ComponentName?.toLowerCase() ===
                    baseName.trim().toLowerCase(),
              );
              if (baseComponent) {
                totalBaseCalculated += baseComponent.CalculatedAmount || 0;
              }
            });

            let newBaseAmount = Math.round(totalBaseCalculated);

            // Apply PF cap if applicable
            if (
              component.ComponentName?.toLowerCase() === "pf" &&
              newBaseAmount > 15000
            ) {
              newBaseAmount = 15000;
            }

            const newCalculatedAmount = Math.round(
              (newBaseAmount * component.PercentageValue) / 100,
            );

            updatedState = updatedState.map((el) => {
              if (
                el.EmpId === employeeId &&
                el.ComponentId === component.ComponentId
              ) {
                return {
                  ...el,
                  BaseAmount: newBaseAmount,
                  CalculatedAmount: newCalculatedAmount,
                };
              }
              return el;
            });
          }
        }
      });

      // STEP 3: Get ALL addition components for deduction recalculation
      const employeeAdditions = updatedState.filter(
        (item) =>
          item.EmpId === employeeId &&
          (item.ComponentType === "Addition type" ||
            item.ComponentType === "Addition"),
      );

      // STEP 4: Recalculate ALL other deductions based on their dependencies
      const employeeDeductions = updatedState.filter(
        (item) =>
          item.EmpId === employeeId &&
          (item.ComponentType === "Deduction type" ||
            item.ComponentType === "Deduction") &&
          item.ComponentId !== originalDeduction.ComponentId && // Skip the edited one
          item.PercentageValue &&
          item.ValueType?.toLowerCase().includes("percentage") &&
          (item.WageTypeName || item.WageComponentName),
      );

      employeeDeductions.forEach((deduction) => {
        const baseNamesString =
          deduction.WageTypeName || deduction.WageComponentName;
        const baseNames = baseNamesString.split("+");

        let totalBaseCalculated = 0;

        baseNames.forEach((baseName) => {
          // First, try to find in additions
          let baseComponent = employeeAdditions.find(
            (item) =>
              item.ComponentName?.toLowerCase() ===
              baseName.trim().toLowerCase(),
          );

          // If not found in additions, check in all components (could be another deduction)
          if (!baseComponent) {
            baseComponent = updatedState.find(
              (item) =>
                item.EmpId === employeeId &&
                item.ComponentName?.toLowerCase() ===
                  baseName.trim().toLowerCase(),
            );
          }

          if (baseComponent) {
            totalBaseCalculated += baseComponent.CalculatedAmount || 0;
          }
        });

        // Apply component-specific caps
        let newBaseAmount = Math.round(totalBaseCalculated);

        if (
          deduction.ComponentName?.toLowerCase() === "pf" &&
          newBaseAmount > 15000
        ) {
          newBaseAmount = 15000;
        }

        const deductionPercentage = Number(deduction.PercentageValue || 0);
        const newCalculatedAmount = Math.round(
          (newBaseAmount * deductionPercentage) / 100,
        );

        updatedState = updatedState.map((item) => {
          if (
            item.EmpId === employeeId &&
            item.ComponentId === deduction.ComponentId
          ) {
            return {
              ...item,
              BaseAmount: newBaseAmount,
              CalculatedAmount: newCalculatedAmount,
            };
          }
          return item;
        });
      });

      return updatedState;
    });

    // Reset state
    setEditDeductionIndex(null);
    setEditDeductionAmount("");
  };

  useEffect(() => {
    const savedFilter = getSecureItem("payrollApprovedFilter");
    if (savedFilter) {
      setPayrollApproveFilter(savedFilter);
      setTemp({ ...temp, payrollApprovedFilter: savedFilter });
    }
  }, []);

  useEffect(() => {
    // Only reset if:
    // 1. The data length changed significantly (not just a small change)
    // 2. The current page would be out of bounds with the new data
    if (filteredPayrollData?.length !== lastDataLength) {
      const newTotalPages = Math.ceil(
        filteredPayrollData?.length / itemsPerPage,
      );
      if (currentPage > newTotalPages) {
        setCurrentPage(1);
      }
      setLastDataLength(filteredPayrollData?.length);
    }
  }, [filteredPayrollData, itemsPerPage, currentPage, lastDataLength]);
  // Add a ref to track if the initial processing has been done
  const initialProcessingDoneRef = useRef(false);

  useEffect(() => {
    // Only run on initial load when data is available and hasn't been processed yet
    if (
      !initialProcessingDoneRef.current &&
      currentItems?.length > 0 &&
      additionsDeductions?.length > 0
    ) {
      // Process all employees
      processAllEmployees();
      // Mark as processed so this doesn't run again
      initialProcessingDoneRef.current = true;
    }
  }, [currentItems, additionsDeductions]);

  useEffect(() => {
    // Get the current date
    const currentDate = new Date();

    // Calculate the first day of the current month
    const firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      2,
    );

    // Calculate the last day of the current month
    const lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      1,
    );

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split("T")[0];

    // Set default dates
    setFromDate(formatDate(firstDay));
    setToDate(formatDate(lastDay));
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await GetDynamicOptions({
          optionType: "SalaryGenerationOption",
        });
        setSalaryOptions(response.data.data);
      } catch (error) {
        console.error("Error fetching salary options:", error);
      }
    };

    fetchOptions();
  }, []);

  useEffect(() => {
    if (PayrollData.length > 0) {
      const initialSelected = PayrollData.map((emp) => emp?.IsChecked == 2);
      //console.log("initialSelected", initialSelected);

      setSelectedEmployees(initialSelected);
    }
  }, [PayrollData]);

  useEffect(() => {
    // Get current year and month
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two-digit format

    const currentMonth = `${year}-${month}`;
    setSelectedMonth(currentMonth);
    handleMonthChange({ target: { value: currentMonth } });
  }, []);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
        //console.log(category, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchcategory();
  }, []);

  useEffect(() => {
    const fetchAdditionDeductionType = async () => {
      try {
        const response = await getAdditionDiductionType(UID);

        setAdditionDidductionType(response.data.data);
      } catch (error) {
        console.error("Error fetching addition/deduction types:", error);
      }
    };

    fetchAdditionDeductionType();
  }, [UID]);

  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setdesignation(response);
        //console.log(designation, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchdesignation();
  }, []);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);

        setGroup(response);
        //console.log(group, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        setDepartment(response);
        //console.log(Department, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);

        setFilterProfitcenter(response);
        //console.log(FilterProfitcenter, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchfilterProfitecenter();
  }, []);

  useEffect(() => {
    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;

      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  useEffect(() => {
    setDataFilter(PayrollData);
  }, [PayrollData]);

  useEffect(() => {
    console.log(additionsDeductions, "dadads");
  }, [additionsDeductions]);

  return (
    <>
      {breakdownModalOpen && (
        <SalaryBreakdownModal
          isOpen={breakdownModalOpen}
          onClose={closeBreakdownModal}
          employee={PayrollData.find((emp) => emp.EmpId === selectedEmployeeId)}
          editableWorkingDays={editableWorkingDays}
          additionsDeductions={additionsDeductions} // Pass additionsDeductions
        />
      )}
      {isAdditionsModalOpen && (
        <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-1/2 overflow-scroll h-[500px]">
            <h2 className="text-xl font-bold mb-4">Additions Details</h2>

            {/* Add Addition Button */}

            {/* Render Addition Inputs */}
            {addition.length > 0 ? (
              <div className="mb-6">
                <table className="w-full border-collapse mb-4">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="p-2 text-left border">Description</th>
                      <th className="p-2 text-left border">Amount</th>
                      <th className="p-2 text-left border">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addition.map((item, index) => (
                      <tr key={index} className="border">
                        <td className="p-2 border">
                          <select
                            className="border border-gray-300 rounded p-2 w-full"
                            value={item.additionDescription || ""}
                            onChange={(e) =>
                              handleAddaddtionChange(
                                index,
                                "additionDescription",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select Addition</option>
                            {additionDidductionType
                              .filter((el) => el.Type == "Addition")
                              .map((el, idx) => (
                                <option key={idx} value={el.Name}>
                                  {el.Name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td className="p-2 border">
                          <input
                            type="number"
                            min="0"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e") {
                                e.preventDefault(); // Prevent negative sign and scientific notation
                              }
                            }}
                            className="border border-gray-300 rounded p-2 w-full"
                            value={item.additionAmount || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (Number(value) >= 0 || value === "") {
                                handleAddaddtionChange(
                                  index,
                                  "additionAmount",
                                  value,
                                );
                              }
                            }}
                          />
                        </td>
                        <td className="p-2 border flex justify-center">
                          <button
                            onClick={handleAddAddition}
                            className="btn btn-secondary "
                          >
                            <IconPlus className="text-white w-[18px] h-[18px]" />
                          </button>
                          <button
                            onClick={() => handleRemoveAddition(index)}
                            className="btn btn-danger ml-4"
                          >
                            <IconTrash className="text-white w-[18px] h-[18px]" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <button
                onClick={handleAddAddition}
                className="btn btn-secondary mb-2 "
              >
                Add Additions
                <IconPlus className="text-white w-[18px] h-[18px]" />
              </button>
            )}

            {/* Additions Summary */}
            <div className="mb-6 border border-gray-200 rounded-lg shadow-md p-4">
              <h2 className="text-lg font-semibold text-center mb-4">
                Additions Summary
              </h2>
              <table className="w-full border-collapse mb-4">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 text-left border">Component</th>
                    <th className="p-2 text-left border">Type</th>
                    <th className="p-2 text-left border">Base Amount</th>
                    <th className="p-2 text-left border">Percentage</th>
                    <th className="p-2 text-right border">Amount</th>
                    <th className="p-2 text-right border">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {additionsDeductions
                    .filter(
                      (l) =>
                        l.EmpId === employeeId &&
                        (l.ComponentType === "Addition type" ||
                          l.ComponentType === "Addition"),
                    )
                    .map((AD, index) => {
                      const isPercentage = AD.ValueType === "Percentage";
                      const calculatedAmount = isPercentage
                        ? (AD.BaseAmount * AD.PercentageValue) / 100
                        : AD.CalculatedAmount;

                      return (
                        <tr key={index} className="border">
                          <td className="p-2 border font-medium">
                            {AD.ComponentName}
                          </td>
                          <td className="p-2 border">
                            {AD.WageTypeName || "-"}
                          </td>

                          <td className="p-2 border">
                            {AD.WageTypeId === null ||
                            AD.WageTypeId === undefined ? (
                              <>-</>
                            ) : (
                              <>₹{AD.BaseAmount}</>
                            )}
                          </td>
                          {console.log(AD, "dasdasd")}
                          <td className="p-2 border">{AD.PercentageValue}</td>
                          <td className="p-2 border text-right font-medium">
                            {editAdditionIndex === index ? (
                              <input
                                type="number"
                                min="0"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === "-" || e.key === "e") {
                                    e.preventDefault();
                                  }
                                }}
                                value={editAdditionAmount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (Number(value) >= 0 || value === "") {
                                    setEditAdditionAmount(value);
                                  }
                                }}
                                className="border border-gray-300 rounded p-1 w-full"
                              />
                            ) : (
                              `₹${Math.round(calculatedAmount).toFixed(2)}`
                            )}
                          </td>
                          <td className="p-2 border flex justify-center">
                            {editAdditionIndex === index ? (
                              <>
                                <button
                                  onClick={() => handleSaveAdditionEdit(index)}
                                  className="btn btn-success ml-2"
                                >
                                  Save
                                </button>
                                <button
                                  onClick={() => {
                                    setEditAdditionIndex(null);
                                    setEditAdditionAmount("");
                                  }}
                                  className="btn btn-danger ml-2"
                                >
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  onClick={() => handleDelete(index)}
                                  className="btn btn-danger ml-2"
                                >
                                  <IconTrash className="text-white w-[18px] h-[18px]" />
                                </button>
                                <button
                                  onClick={() => {
                                    setEditAdditionIndex(index);
                                    setEditAdditionAmount(calculatedAmount);
                                  }}
                                  className="btn btn-primary ml-2"
                                >
                                  <IconEdit className="text-white w-[18px] h-[18px]" />
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-50">
                    <td
                      colSpan="4"
                      className="p-2 border font-semibold text-right"
                    >
                      Total Additions:
                    </td>
                    <td className="p-2 border text-right font-bold">
                      ₹ {footerTotalAdditions}
                    </td>

                    <td
                      colSpan="4"
                      className="p-2 border font-semibold text-right"
                    ></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Save and Close Buttons */}
            <div className="flex justify-end gap-2 mt-4">
              <button onClick={handleSaveAddition} className="btn btn-success">
                Save Additions
              </button>
              <button
                onClick={toggleAdditionsModal}
                className="btn btn-primary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeductionsModalOpen && (
        <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-1/2 overflow-scroll h-[500px]">
            <h2 className="text-xl font-bold mb-4">Deductions Details</h2>

            {/* Add Deduction Button - Moved to the top */}

            {/* Render Deduction Inputs - Moved to the top */}
            {deductions.length > 0 ? (
              <div className="mb-6">
                <table className="w-full border-collapse mb-4">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="p-2 text-left border">Description</th>
                      <th className="p-2 text-left border">Amount</th>
                      <th className="p-2 text-left border">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deductions.map((deduction, index) => (
                      <tr key={index} className="border">
                        <td className="p-2 border">
                          <select
                            className="border border-gray-300 rounded p-2 w-full"
                            value={deduction.description || ""}
                            onChange={(e) =>
                              handleDeductionChange(
                                index,
                                "description",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select Deduction</option>
                            {additionDidductionType
                              .filter((el) => el.Type == "Deduction")
                              .map((el, idx) => (
                                <option key={idx} value={el.Name}>
                                  {el.Name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td className="p-2 border">
                          <input
                            type="number"
                            min="0"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e") {
                                e.preventDefault(); // Prevent typing '-' and scientific notation
                              }
                            }}
                            className="border border-gray-300 rounded p-2 w-full"
                            value={deduction.amount || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (Number(value) >= 0 || value === "") {
                                handleDeductionChange(index, "amount", value);
                              }
                            }}
                          />
                        </td>
                        <td className="p-2 border flex justify-center">
                          <button
                            onClick={handleAddDeduction}
                            className="btn btn-secondary "
                          >
                            <IconPlus className="text-white w-[18px] h-[18px] " />
                          </button>
                          <button
                            onClick={() => handleRemoveDeduction(index)}
                            className="btn btn-danger ml-4"
                          >
                            <IconTrash className="text-white w-[18px] h-[18px] " />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <button
                onClick={handleAddDeduction}
                className="btn btn-secondary mb-4 "
              >
                Add Deductions
                <IconPlus className="text-white w-[18px] h-[18px] " />
              </button>
            )}

            <div className="mb-6 border border-gray-200 rounded-lg shadow-md p-4">
              <h2 className="text-lg font-semibold text-center mb-4">
                Deductions Summary
              </h2>
              {/* Deductions List as Table */}
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 border">Component</th>
                    <th className="p-2 border">Wage Type</th>
                    <th className="p-2 border">Base Amount</th>
                    <th className="p-2 border">%</th>
                    <th className="p-2 border text-right">Amount</th>
                    <th className="p-2 border">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {additionsDeductions
                    .filter(
                      (l) =>
                        l.EmpId === employeeId &&
                        (l.ComponentType === "Deduction type" ||
                          l.ComponentType === "Deduction"),
                    )
                    .map((AD, index, fullList) => {
                      // ❌ Skip 'DA' from deduction table
                      if (AD.ComponentName?.toLowerCase() === "da") return null;

                      // 🧠 Skip Nested Percentage if a matching Percentage exists with BaseAmount > 15000
                      if (
                        AD.ValueType === "Nested Percentage" &&
                        fullList.some(
                          (other) =>
                            other.ComponentId === AD.ComponentId &&
                            other.ValueType === "Percentage" &&
                            Number(other.BaseAmount) > 15000,
                        )
                      ) {
                        return null;
                      }

                      const isPercentage = AD.ValueType === "Percentage";
                      const isESI = AD.ComponentName?.toLowerCase() === "esi";

                      // ✅ ESI: Use exact CalculatedAmount, no ceiling
                      // ✅ PF and others: Apply 15000 ceiling
                      const calculatedAmount = isESI
                        ? AD.CalculatedAmount
                        : isPercentage
                          ? (AD.BaseAmount >= 15000
                              ? 15000 * AD.PercentageValue
                              : AD.BaseAmount * AD.PercentageValue) / 100
                          : AD.CalculatedAmount;

                      return (
                        <tr key={index} className="border">
                          <td className="p-2 border font-medium">
                            {AD.ComponentName}
                          </td>

                          {/* ✅ Wage Type column: show "Basic + DA" for PF, "Basic + DA" or "Basic" for ESI */}
                          <td className="p-2 border">{AD.WageTypeName}</td>

                          {/* Base Amount */}
                          <td className="p-2 border">
                            {AD.WageTypeId === null ||
                            AD.WageTypeId === undefined ? (
                              <></>
                            ) : (
                              <>
                                ₹
                                {/* ✅ ESI: Show exact BaseAmount, PF: Apply 15000 ceiling */}
                                {AD.BaseAmount}
                              </>
                            )}
                          </td>

                          {/* Percentage Value */}
                          <td className="p-2 border">{AD.PercentageValue}</td>

                          {/* Calculated Amount */}
                          <td className="p-2 border text-right font-medium">
                            {editDeductionIndex === index ? (
                              <input
                                type="number"
                                min="0"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === "-" || e.key === "e") {
                                    e.preventDefault(); // block '-' and scientific notation
                                  }
                                }}
                                className="border border-gray-300 rounded p-1 w-full"
                                value={editDeductionAmount}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  // allow only empty string (clearing) or non‑negative numbers
                                  if (val === "" || Number(val) >= 0) {
                                    setEditDeductionAmount(val);
                                  }
                                }}
                              />
                            ) : (
                              `₹${
                                !isNaN(calculatedAmount) &&
                                calculatedAmount !== null
                                  ? Math.round(calculatedAmount).toFixed(2)
                                  : "0.00"
                              }`
                            )}
                          </td>

                          {/* Action Buttons */}
                          <td className="p-2 border flex justify-between">
                            {editDeductionIndex === index ? (
                              <>
                                <button
                                  onClick={() => handleSaveDeductionEdit(index)}
                                  className="btn btn-success ml-2"
                                >
                                  Save
                                </button>
                                <button
                                  onClick={() => {
                                    setEditDeductionIndex(null);
                                    setEditDeductionAmount("");
                                  }}
                                  className="btn btn-danger ml-2"
                                >
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  onClick={() => handleDeleteDeduction(index)}
                                  className="btn btn-danger ml-2"
                                >
                                  <IconTrash className="text-white w-[18px] h-[18px]" />
                                </button>
                                <button
                                  onClick={() => {
                                    setEditDeductionIndex(index);
                                    setEditDeductionAmount(calculatedAmount);
                                  }}
                                  className="btn btn-primary ml-2"
                                >
                                  <IconEdit className="text-white w-[18px] h-[18px]" />
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-50">
                    <td
                      colSpan="4"
                      className="p-2 border font-semibold text-right"
                    >
                      Total Deductions:
                    </td>

                    <td className="p-2 border text-right font-bold">
                      ₹ {footerTotalDeductions.toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button onClick={handleSave} className="btn btn-success">
                Save
              </button>
              <button
                onClick={toggleDeductionsModal}
                className="btn btn-primary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-4">
        <div className="flex flex-col">
          {/* Breadcrumb at the top */}
          <Breadcrumb title="PayRoll Master" />

          <div className="flex items-center gap-4 bg-gray-100 rounded p-2">
            <label className="flex items-center">
              <input
                type="radio"
                name="payrollApprovedFilter"
                value="all"
                checked={payrollApprovedFilter === "all"}
                onChange={handlepayrollApprovedFilterChange}
                className="mr-2"
              />
              All
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="payrollApprovedFilter"
                value="null"
                checked={payrollApprovedFilter === "null"}
                onChange={handlepayrollApprovedFilterChange}
                className="mr-2"
              />
              Payroll not Approved
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="payrollApprovedFilter"
                value="not-null"
                checked={payrollApprovedFilter === "not-null"}
                onChange={handlepayrollApprovedFilterChange}
                className="mr-2"
              />
              Payroll Approved
            </label>
          </div>
          {unApproveModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-lg z-[9999] animate-in fade-in duration-500">
              <div className="bg-gradient-to-b from-gray-900 to-gray-800 p-10 rounded-3xl shadow-2xl border-2 border-red-700 text-center max-w-md w-full mx-4 transform transition-all duration-500 scale-100 hover:scale-[1.03]">
                <div className="mb-8">
                  <div className="w-20 h-20 bg-red-900/50 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
                    <svg
                      className="w-10 h-10 text-red-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-red-400 mb-3 tracking-wide uppercase">
                    Critical Action: Unauthorize Payroll?
                  </h3>
                  <p className="text-gray-300 text-base mb-4">
                    <span className="font-semibold text-red-500">WARNING:</span>{" "}
                    Unauthorizing the payroll will{" "}
                    <span className="font-bold text-red-400">reset</span> all
                    newly additions and deductions. This action cannot be
                    undone.
                  </p>

                  <label className="block text-gray-300 font-semibold text-left mb-2">
                    Reason for Unauthorization:
                  </label>
                  <input
                    type="text"
                    value={unApproveUser[0].Reason}
                    onChange={(e) =>
                      setUnApproveUser([{ Reason: e.target.value }])
                    }
                    className="w-full px-4 py-3 bg-gray-700/50 border-2 border-red-600 rounded-lg text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
                    placeholder="State the reason for this critical action..."
                  />
                </div>

                <div className="flex gap-4">
                  <button
                    onClick={handleUnAutherize}
                    disabled={loading || !unApproveUser[0].Reason.trim()}
                    className="flex-1 bg-gradient-to-r from-red-600 to-red-800 hover:from-red-700 hover:to-red-900 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-red-500/40 focus:outline-none focus:ring-4 focus:ring-red-400 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center">
                        <svg
                          className="w-5 h-5 mr-2 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8 8 8 0 01-8-8z"
                          ></path>
                        </svg>
                        Processing...
                      </span>
                    ) : (
                      "Confirm Unauthorization"
                    )}
                  </button>
                  <button
                    onClick={handlecloseUnapproveModal}
                    className="flex-1 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-gray-200 font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-gray-500"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Filter Row */}
          <div className="flex items-center space-x-4 w-full overflow-x-auto py-2">
            {/* Salary Option Select */}
            <div className="flex flex-col">
              <label htmlFor="salary-options" className="font-medium mb-1">
                Salary Option:
              </label>
              <select
                id="salary-options"
                className="border rounded p-2 w-[200px]"
                value={selectedOption}
                onChange={handleSelectChange}
              >
                {salaryOptions.map((option, index) => (
                  <option key={index} value={option.OptionName}>
                    {option.OptionName}
                  </option>
                ))}
              </select>
            </div>

            {selectedOption !== "Daily" && selectedOption !== "Weekly" ? (
              <div className="flex flex-col">
                <label htmlFor="choose-month" className="font-medium mb-1">
                  Choose Month:
                </label>
                <input
                  type="month"
                  id="choose-month"
                  className="border rounded p-2 w-[200px]"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  max={new Date().toISOString().slice(0, 7)} // ✅ Restricts to current/past months
                />
              </div>
            ) : (
              <div className="flex flex-row gap-4">
                <div className="flex flex-col">
                  <label htmlFor="fromDate" className="font-medium mb-1">
                    From Date:
                  </label>
                  <input
                    type="date"
                    id="fromDate"
                    className="border rounded p-2 w-[200px]"
                    value={fromDate}
                    onChange={(e) => handleDateChange("from", e.target.value)}
                    // max={new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="toDate" className="font-medium mb-1">
                    To Date:
                  </label>
                  <input
                    type="date"
                    id="toDate"
                    className="border rounded p-2 w-[200px]"
                    value={toDate}
                    onChange={(e) => handleDateChange("to", e.target.value)}
                    // max={new Date().toISOString().split("T")[0]}
                  />
                </div>
              </div>
            )}

            {/* View Button */}
            <div className="flex flex-col justify-end mt-[21px]">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleViewClick}
              >
                View
              </button>
            </div>

            <div className="flex flex-col">
              <label htmlFor="employee-search" className="font-medium mb-1">
                Search Employees
              </label>
              <input
                type="search"
                id="employee-search"
                className="border rounded p-2 w-[300px]"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Name/Code..."
              />
            </div>

            {/* Filter Method Select */}
            <div className="flex flex-col">
              <label htmlFor="filter-method" className="text-sm mb-1">
                Filter By
              </label>
              <select
                id="filter-method"
                name="filter-method"
                className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                value={filterMethod}
                onChange={(e) => setFilterMethod(e.target.value)}
              >
                <option value="">Filter By</option>
                <option value="CategoryId">Category</option>
                <option value="ProfitCenterID">Profit Center</option>
                <option value="GroupId">Group</option>
                <option value="DesignationId">Designation</option>
                <option value="DepartmentID">Department</option>
              </select>
            </div>

            {/* Dynamic Options Select */}
            <div className="flex flex-col">
              <label htmlFor="dynamic-options" className="text-sm mb-1">
                Choose Option
              </label>
              <select
                id="dynamic-options"
                name="dynamic-options"
                className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                onChange={(e) => {
                  const selectedOption = dropdownOptions?.find(
                    (option) => option.Name?.toString() === e.target.value,
                  );
                  if (selectedOption) {
                    handleFilterChange(
                      filterMethod,
                      selectedOption.Name,
                      selectedOption.Name,
                    );
                  }
                }}
              >
                <option value="" selected>
                  Choose One
                </option>
                {dropdownOptions?.length > 0 &&
                  dropdownOptions?.map((option) => (
                    <option key={option.Id} value={option.Name}>
                      {option.Name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Clear Button */}
            <div className="flex flex-col justify-end mt-[21px]">
              <button onClick={handleClearFilter} className="btn btn-danger">
                Clear
              </button>
            </div>

            {/* Employee Search */}
          </div>
        </div>

        <div>
          <table className="table-auto w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                {(payrollApprovedFilter === "all" ||
                  payrollApprovedFilter === "null") && (
                  <th className="border border-gray-300 px-4 py-2">
                    <input
                      type="checkbox"
                      checked={apprveall} // directly tied to state
                      onChange={handleSelectAll}
                      disabled={unauthorizeAllChecked == true}
                    />
                    Approve All{" "}
                    {/* (
                  {Object.values(selectedEmployees).filter(Boolean).length}/
                  {filteredPayrollData.filter(emp => emp.NetSalary > 0 && emp.TotalAdditions > 0 && emp.IsChecked !== 1).length}
                  ) */}
                  </th>
                )}
                {(payrollApprovedFilter === "all" ||
                  payrollApprovedFilter === "not-null") && (
                  <th className="border border-gray-300 px-4 py-2">
                    <input
                      type="checkbox"
                      checked={unauthorizeAllChecked} // directly controlled by state
                      onChange={handleSelectAllApproved}
                      disabled={apprveall == true}
                    />{" "}
                    UnAuthorize All
                    {/* (
  {Object.values(selectedEmployeesForUnauthorize).filter(Boolean).length}/
  {filteredPayrollData.filter(emp => emp.IsChecked == 1).length}
  ) */}
                  </th>
                )}

                <th className="border border-gray-300 px-4 py-2">
                  Employee Name
                </th>

                <th className="border border-gray-300 px-4 py-2">
                  Total Working Days
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Employee Working Days
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Working Hours
                </th>
                <th className="border border-gray-300 px-4 py-2">Total LOP</th>
                <th className="border border-gray-300 px-4 py-2">
                  HalfDay Cut
                </th>
                <th className="border border-gray-300 px-4 py-2"> Late Cut </th>
                <th className="border border-gray-300 px-4 py-2">
                  {" "}
                  Halfday sick{" "}
                </th>

                <th className="border border-gray-300 px-4 py-2">
                  Payroll days
                </th>
                <th className="border border-gray-300 px-4 py-2">Additions</th>
                <th className="border border-gray-300 px-4 py-2">Deductions</th>
                <th className="border border-gray-300 px-4 py-2">Net Total</th>
              </tr>
            </thead>
            <tbody>
              {currentItems?.length > 0 ? (
                currentItems?.map((employee, index) => {
                  const baseAmount = additionsDeductions
                    .filter(
                      (l) =>
                        l.EmpId === employee?.EmpId &&
                        l.WageTypeName?.toLowerCase() === "basic" &&
                        l.ComponentName?.toLowerCase() === "basic",
                    )
                    .reduce((total, item) => total + (item.BaseAmount || 0), 0);

                  const TotalCalculatedDeduction = Math.round(
                    additionsDeductions
                      .filter(
                        (l) =>
                          l.EmpId === employee?.EmpId &&
                          (l.ComponentType === "Deduction type" ||
                            l.ComponentType === "Deduction"),
                      )
                      .reduce((total, AD, _, fullList) => {
                        // ❌ Skip 'DA' from deduction total
                        if (AD.ComponentName?.toLowerCase() === "da")
                          return total;

                        // Exclude "Nested Percentage" if matching "Percentage" exists with BaseAmount > 15000
                        if (
                          AD.ValueType === "Nested Percentage" &&
                          fullList.some(
                            (other) =>
                              other.ComponentId === AD.ComponentId &&
                              other.ValueType === "Percentage" &&
                              Number(other.BaseAmount) > 15000,
                          )
                        ) {
                          return total;
                        }

                        let amount = 0;
                        const isESI = AD.ComponentName?.toLowerCase() === "esi"; // ✅ ESI Check

                        if (AD.ValueType === "Percentage") {
                          const baseAmount = Number(AD.BaseAmount || 0);

                          // ✅ ESI: No ceiling, use exact BaseAmount
                          // ✅ PF and others: Apply 15000 ceiling
                          const cappedBase = isESI
                            ? baseAmount // ← ESI uses full amount
                            : baseAmount > 15000
                              ? 15000 // ← PF capped at 15000
                              : baseAmount; // ← Others use actual amount if < 15000

                          amount =
                            (cappedBase * Number(AD.PercentageValue || 0)) /
                            100;
                        } else {
                          amount = Number(AD.CalculatedAmount || 0);
                        }

                        return total + (isNaN(amount) ? 0 : amount);
                      }, 0),
                  );
                  const TotalCalculatedAddition = Math.round(
                    additionsDeductions
                      .filter(
                        (l) =>
                          l.EmpId === employee?.EmpId &&
                          (l.ComponentType === "Addition type" ||
                            l.ComponentType === "Addition"),
                      )
                      .reduce((total, AD) => {
                        // Calculate the amount based on ValueType
                        const amount =
                          AD.ValueType === "Percentage"
                            ? (Number(AD.BaseAmount) *
                                Number(AD.PercentageValue || 0)) /
                              100
                            : Number(AD.CalculatedAmount || 0);

                        // Add the valid amount to total, ensuring NaN values are not added
                        return total + (isNaN(amount) ? 0 : amount);
                      }, 0),
                  );

                  const netTotal =
                    (TotalCalculatedAddition ?? 0) -
                    (TotalCalculatedDeduction ?? 0);
                  const threshold = baseAmount * 0.25; //
                  const rowColor =
                    employee?.IsChecked == "1" || employee?.IsChecked == 1
                      ? (!employee?.StartDate && !employee?.EndDate) ||
                        (employee?.StartDate?.slice(0, 10) === fromDate &&
                          employee?.EndDate?.slice(0, 10) === toDate)
                        ? "bg-green-100"
                        : "bg-[#ffff99]"
                      : selectedEmployees[employee?.EmpId]
                        ? "bg-green-100"
                        : netTotal < threshold
                          ? "bg-red-100"
                          : "";

                  return (
                    <tr key={index} className={rowColor}>
                      {(payrollApprovedFilter === "all" ||
                        payrollApprovedFilter === "null") && (
                        <td className="border border-gray-300 px-4 py-2">
                          {(() => {
                            /* ---- 1. Payrolldays (exact same formula you show in the “Payroll days” column) ---- */
                            const payrolldays =
                              employee?.payrolldays ??
                              (editableWorkingDays[employee?.EmpId] != null
                                ? (editableWorkingDays[employee?.EmpId] ?? 0) +
                                  (employee?.TotalLeaveDays ?? 0) +
                                  (employee?.TotalHalfDay ?? 0) -
                                  (employee?.LateCut ?? 0)
                                : (employee?.EmployeeTotalWorkingDays ?? 0) +
                                  (employee?.TotalLeaveDays ?? 0) +
                                  (employee?.TotalHalfDay ?? 0) -
                                  (employee?.LateCut ?? 0));

                            /* ---- 2. Late-deduction pending check ---- */
                            const isLateDeductionPending = DeductionData.find(
                              (el) =>
                                el.EmpId === employee?.EmpId &&
                                (el.DeductionStatus == null ||
                                  el.DeductionStatus === undefined ||
                                  el.DeductionStatus == 0),
                            );

                            /* ---- 3. Final disable condition ---- */
                            const isDisabled =
                              employee?.IsChecked || // already approved
                              isLateDeductionPending || // late deduction pending
                              payrolldays <= 0; // **payrolldays is 0**

                            return (
                              <>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedEmployees[employee?.EmpId] ?? false
                                  }
                                  onChange={() =>
                                    handleEmployeeCheckboxChange(
                                      employee?.EmpId,
                                    )
                                  }
                                  disabled={isDisabled}
                                />
                                {isLateDeductionPending && (
                                  <span className="text-red-500 ml-2">
                                    (Late Deduction Pending)
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </td>
                      )}

                      {(payrollApprovedFilter === "all" ||
                        payrollApprovedFilter === "not-null") && (
                        <td className="border border-gray-300 px-4 py-2">
                          <input
                            type="checkbox"
                            checked={
                              selectedEmployeesForUnauthorize[
                                employee?.EmpId
                              ] || false
                            }
                            onChange={() =>
                              handleEmployeeCheckboxChangeApproved(
                                employee?.EmpId,
                              )
                            }
                            // disabled={employee?.IsChecked || TotalCalculatedAddition == 0}
                          />
                        </td>
                      )}

                      <td className="border border-gray-300 px-4 py-2 relative group">
                        {employee?.Name} ({employee?.Code})
                        {employee?.StartDate &&
                          employee?.EndDate &&
                          (employee?.StartDate.slice(0, 10) !== fromDate ||
                            employee?.EndDate.slice(0, 10) !== toDate) && (
                            <div className="absolute z-10 top-full mt-1 left-0 bg-white border border-gray-300 text-sm text-gray-800 px-2 py-1 rounded shadow-lg w-max opacity-0 group-hover:opacity-100 transition-opacity">
                              Start: {employee?.StartDate.slice(0, 10)} <br />
                              End: {employee?.EndDate.slice(0, 10)}
                            </div>
                          )}
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        {employee?.TotalWorkingDays}
                      </td>
                      <td className="border border-gray-300 p-4 flex flex-col space-y-3">
                        {/* Number input - full width at top */}
                        <div className="w-full">
                         <input
  type="number"
  step="0.5"
  onWheel={(e) => e.target.blur()}
  className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none"
  value={
    editableWorkingDays[employee?.EmpId] ??
    employee?.EmployeeTotalWorkingDays
  }
  disabled={
    !editingEmployees[employee?.EmpId] ||
    employee?.IsChecked
  }
  min={0}
  max={
    (employee?.TotalWorkingDays ?? 0)
    - (employee?.TotalLeaveDays ?? 0)
    - (employee?.TotalHalfDay ?? 0)
    - (employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT ?? 0)
    - (employee?.LateCut ?? 0)
    - (employee?.HalfSickLeave ?? 0)
  }
  onChange={(e) => {
    let value = parseFloat(e.target.value);
    const max =
      (employee?.TotalWorkingDays ?? 0)
      - (employee?.TotalLeaveDays ?? 0)
      - (employee?.TotalHalfDay ?? 0)
      - (employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT ?? 0)
      - (employee?.LateCut ?? 0)
      - (employee?.HalfSickLeave ?? 0);

    if (isNaN(value)) value = 0;

    // clamp
    if (value < 0) value = 0;
    if (value > max) value = max;

    // force only .0 or .5 steps
    value = Math.round(value * 2) / 2;

    handleWorkingDaysChange(employee?.EmpId, value);
  }}
/>
                        </div>

                        {/* Remark section in the middle */}
                        {editingEmployees[employee?.EmpId] && (
                          <div className="w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Remarks <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                              <textarea
                                className="w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none min-h-[80px] transition-all"
                                placeholder="Add your remarks here..."
                                value={employee?.Remark}
                                onChange={(e) =>
                                  handelChange(employee?.EmpId, e)
                                }
                              ></textarea>
                              <div className="absolute bottom-2 right-2 text-xs text-gray-500">
                                {employee?.Remark?.length || 0} chars
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Button at the bottom */}
                        {!employee?.IsChecked && (
                          <div className="flex justify-end">
                            {!editingEmployees[employee?.EmpId] ? (
                              <button
                                className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2 px-4 rounded transition-colors duration-200 flex items-center"
                                onClick={() =>
                                  handleWorkingDaysEdit(employee?.EmpId)
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 mr-1"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                  />
                                </svg>
                                Edit
                              </button>
                            ) : (
                              <button
                                disabled={
                                  !employee?.Remark ||
                                  (() => {
                                    const currentWorkingDays =
                                      editableWorkingDays[employee?.EmpId] !==
                                      undefined
                                        ? editableWorkingDays[employee?.EmpId]
                                        : employee?.EmployeeTotalWorkingDays;
                                    return (
                                      currentWorkingDays === "" ||
                                      currentWorkingDays <= 0
                                    );
                                  })()
                                }
                                className={`w-full font-medium py-2 px-4 rounded transition-colors duration-200 flex items-center justify-center ${
                                  !employee?.Remark ||
                                  (() => {
                                    const currentWorkingDays =
                                      editableWorkingDays[employee?.EmpId] !==
                                      undefined
                                        ? editableWorkingDays[employee?.EmpId]
                                        : employee?.EmployeeTotalWorkingDays;
                                    return (
                                      currentWorkingDays === "" ||
                                      currentWorkingDays <= 0
                                    );
                                  })()
                                    ? "bg-gray-400 cursor-not-allowed text-gray-600"
                                    : "bg-green-600 hover:bg-green-700 text-white"
                                }`}
                                onClick={() =>
                                  handleWorkingDaysSubmit(
                                    employee?.EmpId,
                                    employee?.TotalWorkingDays,
                                    employee?.TotalLeaveDays,
                                    employee, // Pass the employee object
                                  )
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 mr-1"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                  />
                                </svg>
                                Submit
                              </button>
                            )}
                          </div>
                        )}
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          className="border border-gray-300 rounded p-2 w-full"
                          value={
                            editableWorkingDays[employee?.EmpId]
                              ? editableWorkingDays[employee?.EmpId] * 8
                              : employee?.TotalWorkingDays * 8
                          }
                          disabled={employee?.IsChecked}
                          onChange={(e) =>
                            handleWorkingHoursChange(
                              employee?.EmpId,
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-2  whitespace-nowrap">
                        <span className="text-red-500 text-[12px] whitespace-nowrap inline-block">
                          LOP (
{Math.max(
  (employee?.TotalWorkingDays ?? 0)
  - (editableWorkingDays[employee?.EmpId] != null
      ? editableWorkingDays[employee?.EmpId]
      : (employee?.EmployeeTotalWorkingDays ?? 0))
  - (employee?.TotalLeaveDays ?? 0)
  - (employee?.TotalHalfDay ?? 0)
  - (employee?.HalfSickLeave ?? 0)
  - (employee?.LateCut ?? 0)
  - (employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT ?? 0),
  0
)}
)
                        </span>
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        {employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {employee?.LateCut}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {employee?.HalfSickLeave}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <div
                          onClick={() => {
                            sessionStorage.setItem("EmpId", employee?.EmpId);
                            sessionStorage.setItem(
                              "selectedMonth",
                              selectedMonth,
                            );
                            window.open("/musterroll", "_blank");
                          }}
                          className="flex justify-end items-center w-full cursor-pointer text-blue-600 hover:underline"
                        >
                          {employee?.payrolldays
                            ? employee?.payrolldays
                            : editableWorkingDays[employee?.EmpId] != null
                              ? (editableWorkingDays[employee?.EmpId] ?? 0) +
                                (employee?.TotalLeaveDays ?? 0) +
                                (employee?.TotalHalfDay ?? 0) -
                                (employee?.LateCut ?? 0)
                              : (employee?.EmployeeTotalWorkingDays ?? 0) +
                                (employee?.TotalLeaveDays ?? 0) +
                                (employee?.TotalHalfDay ?? 0) -
                                (employee?.LateCut ?? 0)}
                        </div>
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => toggleAdditionsModal(employee?.EmpId)}
                          className="btn btn-success ml-2 w-[100px]"
                          disabled={employee?.IsChecked}
                        >
                          {payrollTotals[
                            employee?.EmpId
                          ]?.totalAdditions.toFixed(2)}
                        </button>
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => toggleDeductionsModal(employee?.EmpId)}
                          disabled={employee?.IsChecked}
                          className="btn btn-danger ml-2 w-[100px]"
                        >
                          {payrollTotals[
                            employee?.EmpId
                          ]?.totalDeductions.toFixed(2)}
                        </button>
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => toggleBreakdownModal(employee?.EmpId)}
                          className="btn btn-info ml-2 w-full text-right"
                        >
                          {payrollTotals[employee?.EmpId]?.netTotal}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="12"
                    className="border border-gray-300 px-4 py-2 text-center"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="button-group">
            <div className="button-group">
              {(payrollApprovedFilter === "all" ||
                payrollApprovedFilter === "null") && (
                <button
                  onClick={() => {
                    setloading(true);
                    setTimeout(() => {
                      handleApprovePayrole();
                    }, 5000); // wait 3 seconds before calling
                  }}
                  className="btn btn-success mt-3 flex-end mr-3"
                  disabled={
                    loading ||
                    !Object.values(selectedEmployees).some(Boolean) || // No employees selected for approval
                    filteredPayrollData.some(
                      (emp) =>
                        selectedEmployees[emp.EmpId] &&
                        (emp.IsChecked === 1 || emp.IsChecked === 2),
                    ) // Any selected employee is already approved
                  }
                >
                  {loading ? "Loading..." : "Approve Payroll"}
                </button>
              )}
              {(payrollApprovedFilter === "all" ||
                payrollApprovedFilter === "not-null") && (
                <button
                  onClick={handleopenunAutherisemodal}
                  className="btn btn-danger mt-3 flex-end"
                  disabled={
                    loading ||
                    !Object.values(selectedEmployeesForUnauthorize).some(
                      Boolean,
                    ) || // No employees selected for unapproval
                    !filteredPayrollData.some((emp) => emp.IsChecked === 1) // No employees are approved
                  }
                >
                  {loading ? "Loading..." : "Un Approve Payroll"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center mt-4">
        <div>
          <span className="text-sm text-gray-700">
            Showing {indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, filteredPayrollData?.length)} of{" "}
            {filteredPayrollData?.length} entries
          </span>

          <select
            className="ml-2 border rounded p-1"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1); // Reset to first page when changing items per page
            }}
          >
            <option value={5}>5 per page</option>
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
          </select>
        </div>

        <div className="flex space-x-1">
          <button
            onClick={() => paginate(1)}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            «
          </button>
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            ‹
          </button>

          {/* Page numbers - show limited range */}
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }

            return (
              <button
                key={pageNum}
                onClick={() => paginate(pageNum)}
                className={`px-3 py-1 border rounded ${
                  currentPage === pageNum ? "bg-blue-500 text-white" : ""
                }`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            ›
          </button>
          <button
            onClick={() => paginate(totalPages)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            »
          </button>
        </div>
      </div>

      {loading && <Loading />}
    </>
  );
}

export default Payrole;
